import { grey } from '@material-ui/core/colors';
import {
  OccupancyRate,
  ADR,
  Revenue,
  ColorbarData,
  Host,
  ProductIDOptionsType,
  PieChartData,
  BarGraphData,
  Listing,
} from 'src/interfaces/idashboard';

import AirbticsProImageUS from 'src/App/assets/airbtics_pro_us_cover.jpg';
import AirbticsProImageUK from 'src/App/assets/airbtics_pro_uk_cover.jpg';
import AirbticsProImageCA from 'src/App/assets/airbtics_pro_ca_cover.jpg';
import AirbticsProImageAU from 'src/App/assets/airbtics_pro_au_cover.jpg';
import SearchListings from './App/Pages/SearchListings/SearchListings';

export const LIGHT_GREY = grey[200];
export const DARK_GREY = grey[600];
export const LIGHT_GREY_2 = grey[400];
export const MID_GREY = '#555';

export const BACKGROUND_COLOR = '#F3FAFB'; //'#f7f8fb'//'#EEFCFB'//

export const COLOR_PRIMARY_DARK = '#037A90';
export const COLOR_PRIMARY = '#3AAFA9'; //"#00C2BA"
export const COLOR_PRIMARY_LIGHT = '#65ccb8';
export const COLOR_FORM_BACKGROUND = '#85CACC';

export const COLOR_ACCENT_1 = '#FF2079'; //"#FE1C80"//"#FF8FCF"
export const COLOR_ACCENT_1_GRADIENT = [
  '#ffe0ed',
  '#ffb3d1',
  '#ff80b2',
  '#ff4d94',
  '#ff1a75',
  '#e6005c',
  '#b30047',
  '#800033',
  '#4d001f',
  '#1a000a',
];
export const COLOR_ACCENT_2 = '#FF5F01'; //"#FF5F01"//"#CE96FB"
export const COLOR_ACCENT_2_CONTRAST = '#64b5f6';
export const COLOR_ACCENT_2_GRADIENT = ['#0a62a9', '#e7f3fe'];
export const COLOR_E = '#551A8B'; //'SAMPLE' WATERMARK
export const COLOR_F = '#ffab00';
export const COLOR_F_CONSTRAST = '#ff8000';
export const COLOR_F_GRADIENT = [
  '#ffeabf',
  '#ffdc95',
  '#ffce6a',
  '#ffc040',
  '#ffb215',
  '#ea9d00',
  '#bf8000',
  '#956400',
  '#6a4700',
  '#402b00',
];
export const COLOR_G_GRADIENT = ['#e5fcff', '#b3f7ff', '#80f2ff', '#4dedff'];
export const COLOR_GREEN = '#00cc00';
export const COLOR_GREEN_ACCENT_1 = '#3AB659';
export const COLOR_RED = '#cc0000';
export const COLOR_RED_LIGHT = '#E32636';
export const COLOR_GREY = '#696969';
export const COLOR_ORANGE = '#FFA500';
export const COLOR_YELLOW = '#EDD94C';
export const COLOR_GOLD = 'FFC700';
export const COLOR_TOOLTIP_BACKGROUND = '#E6F2F2';
export const COLOR_BLACK = '#000';
export const COLOR_BLUE_BLACK_LIGHT = '#292B3D';
export const COLOR_WHITE = '#fff';
export const COLOR_WHITE_ACCENT = '#DAEDE7';
export const COLOR_GOLDEN_YELLOW = '#EDD94C';
export const COLOR_LIGHT_PURPLE = '#8E30FF';
export const COLOR_VERIFIED_TICK = '#42A5F5';

export const SUPPLY_DEMAND_GRAPH_YELLOW = '#E3AF64';
export const SUPPLY_DEMAND_GRAPH_BLUE = '#518FD4';

export const COLOR_AIRBNB_MARKERS = COLOR_ACCENT_1;
export const COLOR_VRBO_MARKER = '#6a6aff';
export const COLOR_BOOKING_COM_MARKER = '#1c39bb';
export const COLOR_TRIPADVISOR_MARKER = '#a9ff39';

// export const COLOR_RANGE_AIRBNB_MARKERS = ['#10D4FF', '#FBEC07', '#FF2079', '#DA1D00'];
export const COLOR_RANGE_AIRBNB_MARKERS = ['#FF9F67', '#FF79AF', '#FF2079', '#DA1D00'];

export const MARKETPLACE_GREEN = '#3FFAC2';

export const POINTER_GREEN = '#4aa59a';

export const COLOR_PALETTE_1 = '#f15b82';

export const INDIVIDUAL_LISTING_TOOLTIP_BUTTON_COLOR = '#315bb5';
export const INDIVIDUAL_LISTING_TOOLTIP_BUTTON_HOVER_COLOR = '#3777ff';

// Color shade for inactive sectors of the pie
export const INACTIVE_COLORS = Array(10).fill(COLOR_PRIMARY);

export const COLORS_PROPERTY_SIZE = [
  '#f05a67',
  '#65CCB8',
  '#faaebe',
  '#ffd85a',
  '#b2cf65',
  '#21c5c7',
  COLOR_PALETTE_1,
];

export const COLORS_BOOKING_TYPE = ['#8E30FF', '#FF5E78', '#65CCB8'];
export const COLORS_BOOKING_LEAD_TIME = ['#1BD6EF', '#FF5E78', '#EDD94C'];
export const COLORS_TOP_3_MARKET_LEADERS = ['#EBEF1B', '#65CCB8', '#FF7723'];

export const INNERPIE_COLORS = [
  COLOR_ACCENT_1,
  COLOR_VRBO_MARKER,
  COLOR_BOOKING_COM_MARKER,
  COLOR_TRIPADVISOR_MARKER,
];

export const COMPETITOR_RATES_COLORS = [
  '#E74645',
  '#DBA507',
  '#1AC0C6',
  '#0D6986',
  '#9768D1',
  '#B64926',
  '#F5487F',
  '#E74645',
  '#679186',
  '#F9B4AB',
];
export const AVAILABLE_NIGHT_COLOR = SUPPLY_DEMAND_GRAPH_BLUE;
export const BOOKED_NIGHT_COLOR = SUPPLY_DEMAND_GRAPH_YELLOW;

export const HOMEPAGE_PINK = '#0E6BA8';
export const HOMEPAGE_DARK_BLUE = '#0E3B43';

export const PAYMENT_MODAL_GREEN = '#61BFBA';
export const PAYMENT_MODAL_GREEN_HOVER = '#1C879B';

export const gradient = [
  'rgba(0, 255, 255, 0)',
  'rgba(0, 255, 255, 1)',
  'rgba(0, 191, 255, 1)',
  'rgba(0, 127, 255, 1)',
  'rgba(0, 63, 255, 1)',
  'rgba(0, 0, 255, 1)',
  'rgba(0, 0, 223, 1)',
  'rgba(0, 0, 191, 1)',
  'rgba(0, 0, 159, 1)',
  'rgba(0, 0, 127, 1)',
  'rgba(63, 0, 91, 1)',
  'rgba(127, 0, 63, 1)',
  'rgba(191, 0, 31, 1)',
  'rgba(255, 0, 0, 1)',
];

export const activeListingAsPerCountryTier = {
  tier1: 1000000,
  tier2: 250000,
  tier3: 50000,
};

export const countryCodeToNumberOfListingsCountryPlan = {
  us: 1000000,
  fr: 1000000,
  ca: 500000,
  au: 500000,
  de: 500000,
  it: 500000,
  jp: 500000,
  gb: 500000,
  other: 250000,
};

export let gradientCss = 'linear-gradient(to right';
for (let i = 0; i < gradient.length; ++i) {
  gradientCss += ', ' + gradient[i];
}
gradientCss += ')';

export const mapStyles = [
  // {
  //   featureType: 'landscape',
  //   stylers: [
  //     {
  //       hue: '#FFBB00',
  //     },
  //     {
  //       saturation: 43.400000000000006,
  //     },
  //     {
  //       lightness: 37.599999999999994,
  //     },
  //     {
  //       gamma: 1,
  //     },
  //   ],
  // },
  {
    featureType: 'road.highway',
    stylers: [
      {
        hue: '#FFC200',
      },
      {
        saturation: -61.8,
      },
      {
        lightness: 45.599999999999994,
      },
      {
        gamma: 1,
      },
    ],
  },
  {
    featureType: 'road.arterial',
    stylers: [
      {
        hue: '#FF0300',
      },
      {
        saturation: -100,
      },
      {
        lightness: 51.19999999999999,
      },
      {
        gamma: 1,
      },
    ],
  },
  {
    featureType: 'road.local',
    stylers: [
      {
        hue: '#FF0300',
      },
      {
        saturation: -100,
      },
      {
        lightness: 52,
      },
      {
        gamma: 1,
      },
    ],
  },
  {
    featureType: 'water',
    stylers: [
      {
        hue: '#0078FF',
      },
      {
        saturation: -13.200000000000003,
      },
      {
        lightness: 2.4000000000000057,
      },
      {
        gamma: 1,
      },
    ],
  },
  {
    featureType: 'poi',
    stylers: [
      {
        hue: '#00FF6A',
      },
      {
        saturation: -1.0989010989011234,
      },
      {
        lightness: 11.200000000000017,
      },
      {
        gamma: 1,
      },
    ],
  },
];

export const mapOptions = {
  styles: mapStyles, // straight out of something like snazzymaps
};

export const staticMapOptions = {
  disableDefaultUI: true,
  draggable: false,
  scrollwheel: false,
  disableDoubleClickZoom: true,
  gestureHandling: 'none',
  zoomControl: false,
  mapTypeControl: false,
  scaleControl: false,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: false,
};

export const sidebarWidth = 175;
export const sidebarClosedWidth = 80;
export const HEADER_HEIGHT = '80px';
export const FILTER_WIDTH = '500px';

export const RoutesMap = {
  Home: '/',
  Login: '/login',
  Register: '/register',
  Calculator: '/airbnb-calculator',
  Discovery: '/markets',
  TailoredRegion: '/tailored',
  VerifyEmail: '/verify-email',
  Data: '/airbnb-data',
  User: '/user',
  Error: '/error',
  Pricing: '/pricing',
  ResetPassword: '/reset-password',
  IBAS: '/admin/ibas',
  ActiveMarkets: '/admin/active-markets',
  CreateBigMarket: '/admin/big-markets/create',
  GetBigMarkets: '/admin/big-markets',
  MyAnalysis: '/my-analysis',
  Admin: '/admin',
  AI: '/ai',
  Partner: '/partner',
  ApiCallsTracker: '/api-calls-tracker',
  MapVisualEditor: '/admin/map-visual-editor',
  CustomDataExportTool: '/admin/custom-data-export-tool',
  AdvancedDashboard: '/advanced-dashboard',
  SearchListing: '/search-listing',
  IndividualListing: '/listing/:listingID',
  IndividualHost: '/host/:hostID',
};

export const ProductIDOptions: ProductIDOptionsType = {
  pro: {
    productID: {
      monthly: 'price_1PNvF6BVoeq938b5bdLIXOCu',
      yearly: 'price_1PNvUUBVoeq938b5EdlyQjQI',
    },
  },
  expert: {
    productID: {
      monthly: 'price_1PNuokBVoeq938b5oAZLxJeH',
      yearly: 'price_1PNuxhBVoeq938b57qNUXqoX',
    },
  },
  scale: {
    productID: {
      monthly: 'price_1PvFTaBVoeq938b5gQ8nvhOd',
      yearly: 'price_1PvFURBVoeq938b5GDURLWaw',
    },
  },
};

export const CountryCodeWithCurrency = {
  US: 'USD',
  EC: 'USD',
  SV: 'USD',
  ZW: 'USD',
  VG: 'USD',
  TC: 'USD',
  TL: 'USD',
  BQ: 'USD',
  FM: 'USD',
  PW: 'USD',
  MH: 'USD',
  PA: 'USD',
  CA: 'CAD',
  UK: 'GBP',
  GS: 'GBP',
  AU: 'AUD',
  CX: 'AUD',
  NR: 'AUD',
  NF: 'AUD',
  HM: 'AUD',
  AT: 'EUR',
  BE: 'EUR',
  HR: 'EUR',
  CY: 'EUR',
  EE: 'EUR',
  FI: 'EUR',
  FR: 'EUR',
  DE: 'EUR',
  GR: 'EUR',
  IE: 'EUR',
  IT: 'EUR',
  LV: 'EUR',
  LT: 'EUR',
  LU: 'EUR',
  MT: 'EUR',
  NL: 'EUR',
  AN: 'EUR',
  PT: 'EUR',
  SK: 'EUR',
  SI: 'EUR',
  ES: 'EUR',
  AD: 'EUR',
  AL: 'EUR',
  AX: 'EUR',
  BA: 'EUR',
  BG: 'EUR',
  BY: 'EUR',
  CH: 'EUR',
  CZ: 'EUR',
  DK: 'EUR',
  FO: 'EUR',
  GB: 'GBP',
  GG: 'EUR',
  GI: 'EUR',
  HU: 'EUR',
  IM: 'EUR',
  IS: 'EUR',
  JE: 'EUR',
  LI: 'EUR',
  MC: 'EUR',
  MD: 'EUR',
  ME: 'EUR',
  MK: 'EUR',
  NO: 'EUR',
  PL: 'EUR',
  RO: 'EUR',
  RS: 'EUR',
  RU: 'EUR',
  SE: 'EUR',
  SJ: 'EUR',
  UA: 'EUR',
  XK: 'EUR',
  MX: 'MXN',
  ZA: 'ZAR',
  IN: 'INR',
  KR: 'KRW',
  JP: 'JPY',
  PH: 'PHP',
  MY: 'MYR',
  AE: 'AED',
};

export const CurrencyWithSubscriptionPrice = {
  USD: {
    pro: {
      monthly: 39.0,
      yearly: 109.0,
    },
    expert: {
      monthly: 119.0,
      yearly: 349.0,
    },
    scale: {
      monthly: 295.0,
      yearly: 750.0,
    },
  },
  CAD: {
    pro: {
      monthly: 49.0,
      yearly: 139.0,
    },
    expert: {
      monthly: 159.0,
      yearly: 459.0,
    },
    scale: {
      monthly: 400.0,
      yearly: 999.0,
    },
  },
  GBP: {
    pro: {
      monthly: 29.0,
      yearly: 85.0,
    },
    expert: {
      monthly: 90.0,
      yearly: 270.0,
    },
    scale: {
      monthly: 225.0,
      yearly: 565.0,
    },
  },
  AUD: {
    pro: {
      monthly: 59.0,
      yearly: 165.0,
    },
    expert: {
      monthly: 179.0,
      yearly: 529.0,
    },
    scale: {
      monthly: 435.0,
      yearly: 995.0,
    },
  },
  EUR: {
    pro: {
      monthly: 35.0,
      yearly: 99.0,
    },
    expert: {
      monthly: 109.0,
      yearly: 319.0,
    },
    scale: {
      monthly: 265.0,
      yearly: 650.0,
    },
  },
  MXN: {
    pro: {
      monthly: 699.0,
      yearly: 1899.0,
    },
    expert: {
      monthly: 1999.0,
      yearly: 5799.0,
    },
    scale: {
      monthly: 5845.0,
      yearly: 14875.0,
    },
  },
  ZAR: {
    pro: {
      monthly: 729.0,
      yearly: 1999.0,
    },
    expert: {
      monthly: 1999.0,
      yearly: 5799.0,
    },
    scale: {
      monthly: 5295.0,
      yearly: 13465.0,
    },
  },
  INR: {
    pro: {
      monthly: 3199.0,
      yearly: 8999.0,
    },
    expert: {
      monthly: 9999.0,
      yearly: 28999.0,
    },
    scale: {
      monthly: 24999.0,
      yearly: 62999.0,
    },
  },
  KRW: {
    pro: {
      monthly: 52999.0,
      yearly: 148999.0,
    },
    expert: {
      monthly: 165000.0,
      yearly: 479000.0,
    },
    scale: {
      monthly: 395000.0,
      yearly: 1000000.0,
    },
  },
  JPY: {
    pro: {
      monthly: 5999.0,
      yearly: 16799.0,
    },
    expert: {
      monthly: 18499.0,
      yearly: 53599.0,
    },
    scale: {
      monthly: 42800.0,
      yearly: 99999.0,
    },
  },
  PHP: {
    pro: {
      monthly: 2199.0,
      yearly: 6159.0,
    },
    expert: {
      monthly: 6999.0,
      yearly: 20299.0,
    },
    scale: {
      monthly: 16695.0,
      yearly: 42425.0,
    },
  },
  MYR: {
    pro: {
      monthly: 179.0,
      yearly: 499.0,
    },
    expert: {
      monthly: 559.0,
      yearly: 1620.0,
    },
    scale: {
      monthly: 1285.0,
      yearly: 3265.0,
    },
  },
  AED: {
    pro: {
      monthly: 139.0,
      yearly: 389.0,
    },
    expert: {
      monthly: 435.0,
      yearly: 1260.0,
    },
    scale: {
      monthly: 1085.0,
      yearly: 2745.0,
    },
  },
};

export const EuropeCountryCodes = [
  'AD',
  'AL',
  'AT',
  'AX',
  'BA',
  'BE',
  'BG',
  'BY',
  'CH',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FO',
  'FR',
  'GB',
  'GG',
  'GI',
  'GR',
  'HR',
  'HU',
  'IE',
  'IM',
  'IS',
  'IT',
  'JE',
  'LI',
  'LT',
  'LU',
  'LV',
  'MC',
  'MD',
  'ME',
  'MK',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'RS',
  'RU',
  'SE',
  'SI',
  'SJ',
  'SK',
  'UA',
  'XK',
];

export const rentalArbitrageCalculatorInputFields = [
  {
    key: 'monthly_rent',
    label: 'Monthly Rent',
    tooltip: 'Rent to be paid for the long term lease to the landlord.',
    input: true,
    unit: '$',
  },
  {
    key: 'monthly_expense',
    label: 'Monthly Expense',
    tooltip:
      'In your monthly expense you can count in things like Utilities, Bills, Subscriptions and Cleaning Fees. These are recurring expenses that you are liable to pay every month. You can also factor in additional state or country wise charges that you have to pay to your local authorities.',
    input: true,
    unit: '$',
  },
  {
    key: 'one_time_cost',
    label: 'One-time Cost',
    tooltip:
      'Apart from paying for your rent, you’ll need to take into account other starting costs like Furnishing, Deposit, Insurance, Appliances, Legal Paperwork and Refurbishing. ',
    input: true,
    unit: '$',
  },
];

export const exchangeRates = {
  USD: {
    symbol: '$',
    rate: 1,
  },
  CAD: {
    symbol: 'C$',
    rate: 1.34,
  },
  GBP: {
    symbol: '£',
    rate: 0.79,
  },
  EUR: {
    symbol: '€',
    rate: 0.92,
  },
  AUD: {
    symbol: 'A$',
    rate: 1.51,
  },
  BRL: {
    symbol: 'R$',
    rate: 4.92,
  },
  ZAR: {
    symbol: 'R',
    rate: 19.13,
  },
  MXN: {
    symbol: 'MX$',
    rate: 17.36,
  },
  INR: {
    symbol: '₹',
    rate: 82.75,
  },
  KRW: {
    symbol: '₩',
    rate: 1305.74,
  },
  JPY: {
    symbol: '¥',
    rate: 143.24,
  },
  PHP: {
    symbol: '₱',
    rate: 55.62,
  },
  MYR: {
    symbol: 'RM',
    rate: 4.67,
  },
  AED: {
    symbol: 'AED',
    rate: 3.67,
  },
  BDT: {
    symbol: '৳',
    rate: 119.48,
  },
  EGP: {
    symbol: 'E£',
    rate: 48.62,
  },
  HKD: {
    symbol: 'HK$',
    rate: 7.8,
  },
  IDR: {
    symbol: 'Rp',
    rate: 15505,
  },
  IRR: {
    symbol: 'IRR',
    rate: 42092.5,
  },
  ILS: {
    symbol: '₪',
    rate: 3.63,
  },
  NZD: {
    symbol: 'NZ$',
    rate: 1.6,
  },
  SGD: {
    symbol: 'S$',
    rate: 1.3,
  },
  THB: {
    symbol: '฿',
    rate: 34.02,
  },
  CHF: {
    symbol: 'CHF',
    rate: 0.85,
  },
  TWD: {
    symbol: 'NT$',
    rate: 32,
  },
};

// default for LockedDigestCard is estimator Dashboard page

const estimatorDummyRevenueGraphData = [
  { date: '2021-03', revenue: 2962 },
  { date: '2021-04', revenue: 3107 },
  { date: '2021-05', revenue: 3298 },
  { date: '2021-06', revenue: 4003 },
  { date: '2021-07', revenue: 3712 },
  { date: '2021-08', revenue: 3901 },
  { date: '2021-09', revenue: 3937 },
  { date: '2021-10', revenue: 2858 },
  { date: '2021-11', revenue: 3185 },
  { date: '2021-12', revenue: 3319 },
  { date: '2022-01', revenue: 2200 },
  { date: '2022-02', revenue: 3223 },
];

const estimatorDummyNightlyRateGraphData = [
  { date: '2021-03', adr: 208 },
  { date: '2021-04', adr: 237 },
  { date: '2021-05', adr: 213 },
  { date: '2021-06', adr: 260 },
  { date: '2021-07', adr: 258 },
  { date: '2021-08', adr: 213 },
  { date: '2021-09', adr: 212 },
  { date: '2021-10', adr: 209 },
  { date: '2021-11', adr: 214 },
  { date: '2021-12', adr: 264 },
  { date: '2022-01', adr: 231 },
  { date: '2022-02', adr: 234 },
];

const estimatorDummyOccupancyRateGraphData = [
  { date: '2021-03', occupancy_rate: 38 },
  { date: '2021-04', occupancy_rate: 39 },
  { date: '2021-05', occupancy_rate: 40 },
  { date: '2021-06', occupancy_rate: 49 },
  { date: '2021-07', occupancy_rate: 48 },
  { date: '2021-08', occupancy_rate: 50 },
  { date: '2021-09', occupancy_rate: 57 },
  { date: '2021-10', occupancy_rate: 39 },
  { date: '2021-11', occupancy_rate: 43 },
  { date: '2021-12', occupancy_rate: 46 },
  { date: '2022-01', occupancy_rate: 32 },
  { date: '2022-02', occupancy_rate: 41 },
];

export const dummyEstimatorData = {
  revenue: estimatorDummyRevenueGraphData,
  adr: estimatorDummyNightlyRateGraphData,
  occupancy_rate: estimatorDummyOccupancyRateGraphData,
};

const sampleListArray = [
  'full',
  51477180,
  'Lovely Palo Alto 2BR w/ Gym, Pool, 3 min drive to Stanford, by Blueground',
  'prohost-api/Hosting-51477180/original/18da5a97-3943-4710-98e8-5274bdbe31aa.jpeg',
  37.43,
  -122.189,
  'entire_home',
  '-1',
  '2',
  2,
  4,
  'Blueground',
  30,
  null,
  405,
  0,
  0,
  't',
  'f',
  'f',
  'f',
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -317,
  -339,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  0,
  0,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  0,
  0,
  304,
  't',
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  't',
  't',
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  0,
  0,
  16.666666666666664,
];

export const sampleListings = [...new Array(8)].map(curr => [...sampleListArray]);

export const dummyImageLinks = [
  'ddb5755b-db1b-4ccd-af2f-b0b3a470148b.jpg',
  'prohost-api/Hosting-50152739/original/e4601d2c-dacd-40e8-81a4-db15da689bbc.jpeg',
  '670a55b3-62d8-4f3f-a604-b31ee0d5f6c7.jpg',
  'miso/Hosting-53688023/original/bc0d43b8-e112-467c-9bf6-de05a4821c56.jpeg',
  '37059356/9d618934_original.jpg',
  'e37ea637-6f09-4b67-b11d-8992c02a50f2.jpg',
  '24158910/60281de7_original.jpg',
];

export let InvestmentSimulationWizardInputKeys = [
  {
    key: 'propertyDetails',
    label: '',
    step: 1,
    header: '',
    substep: '1',
    question: `Great, let's grab your property details so we can simulate your return on investment!`,
    hint: '',
    inputType: 'step',
    placeholder: '',
    unit: '',
    hide: false,
    required: false,
  },
  {
    key: 'propertyPrice',
    label: 'Property Price',
    step: 1,
    header: `Great, Let's grab your property details so we can simulate your return on investement!`,
    substep: 'a',
    question: 'Important question, what is your estimated *property price*?',
    hint: '',
    inputType: 'number',
    placeholder: '',
    unit: '$',
    hide: false,
    required: true,
  },
  {
    key: 'takingLoan',
    label: 'Loan taken',
    step: 1,
    header: `Great, Let's grab your property details so we can simulate your return on investement!`,
    substep: 'a',
    question: 'Are you paying *Mortgage* for this property?',
    hint: '',
    inputType: 'boolean',
    placeholder: '',
    unit: '',
    hide: false,
    required: true,
  },
  {
    key: 'downPayment',
    label: 'Down Payment',
    step: 1,
    header: `Great, Let's grab your property details so we can simulate your return on investement!`,
    substep: 'b',
    question: 'What is your estimated *down payment* for this property?',
    hint: '',
    inputType: 'number',
    placeholder: '',
    unit: '$',
    hide: false,
    required: true,
  },
  {
    key: 'loanTerm',
    label: 'Loan Term',
    step: 1,
    header: `Great, Let's grab your property details so we can simulate your return on investement!`,
    substep: 'c',
    question: 'How long is your loan term?',
    hint: '',
    inputType: 'loanTerm',
    placeholder: '',
    unit: '$',
    hide: false,
    required: true,
  },
  {
    key: 'interestRate',
    label: 'Interest Rate',
    step: 1,
    header: `Great, Let's grab your property details so we can simulate your return on investement!`,
    substep: 'd',
    question: "What's the interest rate?",
    hint: '',
    inputType: 'number',
    placeholder: '',
    unit: '%',
    hide: false,
    required: true,
  },
  // {
  //   key: 'mortgageFees',
  //   label: 'Mortgage Fees',
  //   step: 1,
  //   header: `Great, Let's grab your property details so we can simulate your return on investement!`,
  //   substep: 'e',
  //   question: 'What is your estimated monthly payment to your mortgage provider?',
  //   hint:
  //     'Visit [here](https://www.bankrate.com/mortgages/mortgage-calculator/) if you are unsure how to calculate this',
  //   inputType: 'number',
  //   placeholder: '',
  //   unit: '$',
  //   hide: false,
  //   required: false,
  // },
  {
    key: 'closingCosts',
    label: 'Closing Costs',
    step: 1,
    header: `Great, Let's grab your property details so we can simulate your return on investement!`,
    substep: 'e',
    question: 'Thanks for that, how much do you expect to spend on closing costs?',
    hint: `Closing costs typically range from 3%-6% of the home's purchase price. It includes taxes, legal, property transaction fees etc`,
    inputType: 'number',
    placeholder: '',
    unit: '$',
    hide: false,
    required: false,
  },
  {
    key: 'homeFurnishings',
    label: 'Home Furnishings',
    step: 1,
    header: `Great, Let's grab your property details so we can simulate your return on investement!`,
    substep: 'f',
    question: 'How much do you expect to pay for *furnishing* your new place?',
    hint: 'Put 0 if you already have a house prepared for renting out.',
    inputType: 'number',
    placeholder: '',
    unit: '$',
    hide: false,
    required: false,
  },
  {
    key: 'monthlyExpenses',
    label: '',
    step: 2,
    header: '',
    substep: '2',
    question: `Thank you :) Let's understand your monthly expenses. It'll be quick!`,
    hint: '',
    inputType: 'step',
    placeholder: '',
    unit: '',
    hide: false,
    required: false,
  },
  {
    key: 'electricity',
    label: 'Electricity',
    step: 2,
    header: `Thank you :) Let's understand your monthly expenses. It'll be quick!`,
    substep: 'a',
    question: 'How much do you expect to pay for *electricity* every month?',
    hint: 'Not sure? Use our magic number @MN',
    inputType: 'number',
    placeholder: '73',
    unit: '$',
    hide: false,
    required: false,
  },
  {
    key: 'wifi',
    label: 'Wifi',
    step: 2,
    header: `Thank you :) Let's understand your monthly expenses. It'll be quick!`,
    substep: 'b',
    question: 'How much do you expect to pay for *wifi* every month?',
    hint: 'Not sure? Use our magic number @MN',
    inputType: 'number',
    placeholder: '35',
    unit: '$',
    hide: false,
    required: false,
  },
  {
    key: 'gas',
    label: 'Gas',
    step: 2,
    header: `Thank you :) Let's understand your monthly expenses. It'll be quick!`,
    substep: 'c',
    question: 'How much do you expect to pay for *gas* every month?',
    hint: 'Not sure? Use our magic number @MN',
    inputType: 'number',
    placeholder: '43',
    unit: '$',
    hide: false,
    required: false,
  },
  {
    key: 'annualExpenses',
    label: '',
    step: 3,
    header: '',
    substep: '3',
    question: `Almost there! Let's grab your annual expenses.`,
    hint: '',
    inputType: 'step',
    placeholder: '',
    unit: '',
    hide: false,
    required: false,
  },
  {
    key: 'willUseManagementCompany',
    label: '',
    step: 3,
    header: `Almost there! Let's grab your annual expenses.`,
    substep: 'a',
    question: 'Will you use a *management company*?',
    hint: 'No, if you are going to manage yourself',
    inputType: 'boolean',
    placeholder: '',
    unit: '',
    hide: false,
    required: false,
  },
  {
    key: 'managementFee',
    label: 'Management Fee',
    step: 3,
    header: `Almost there! Let's grab your annual expenses.`,
    substep: 'b',
    question: 'How much percentage does your management company take from your revenue?',
    hint: 'Typically, the standard fees that we see are ranging from 15 - 35%.',
    inputType: 'number',
    placeholder: '20',
    unit: '%',
    hide: true,
    required: false,
  },
  {
    key: 'propertyTax',
    label: 'Property Tax',
    step: 3,
    header: `Almost there! Let's grab your annual expenses.`,
    substep: 'c',
    question: 'How much *property tax* do you need to pay?',
    hint: `It's a tax paid on property owned by an individual or a corporation. For US properties, include both county and country property taxes`,
    inputType: 'number',
    placeholder: '10',
    unit: '%',
    hide: false,
    required: false,
  },
  {
    key: 'lodgingTax',
    label: 'Lodgning Tax',
    step: 3,
    header: `Almost there! Let's grab your annual expenses.`,
    substep: 'd',
    question: 'How much *lodging tax* do you need to pay?',
    hint: '',
    inputType: 'number',
    placeholder: '5',
    unit: '%',
    hide: false,
    required: false,
  },
  {
    key: 'maintenance',
    label: 'Maintenance',
    step: 3,
    header: `Almost there! Let's grab your annual expenses.`,
    substep: 'e',
    question: 'How much do you expect to pay for *maintenance*?',
    hint:
      'Things you need to think about: HOA fees, Reparis & Maintenance, Travel expenses.. Not sure? Tip! $2,319 a year is an average maintenance costs among our users.',
    inputType: 'number',
    placeholder: '2,319',
    unit: '$',
    hide: false,
    required: false,
  },
  {
    key: 'insurance',
    label: 'Insurance',
    step: 3,
    header: `Almost there! Let's grab your annual expenses.`,
    substep: 'f',
    question: 'How much do you expect to pay for *insurance*?',
    hint: 'Tip! $1,765 a year is an average homeowner insurance costs in the US',
    inputType: 'number',
    placeholder: '1,765',
    unit: '$',
    hide: false,
    required: false,
  },
  {
    key: 'other',
    label: 'Other',
    step: 3,
    header: `Almost there! Let's grab your annual expenses.`,
    substep: 'g',
    question: `This is the last chance to put your remaining expenses. If there are any expenses that you haven't filled in the previous step, please add them and put the annaul sum here.`,
    hint: `If you are sure you've put all the expenses, just put 0!`,
    inputType: 'number',
    placeholder: '',
    unit: '$',
    hide: false,
    required: false,
  },
  {
    key: 'summary',
    label: '',
    step: 4,
    header: `Summing it up!`,
    substep: '',
    question: '',
    hint: '',
    inputType: '',
    unit: '',
    hide: false,
    required: false,
  },
];

export const getInvestmentCalInputKeys = (isLegacy: 0 | 1) => {
  return {
    annualRevenue: {
      key: 'annual_revenue_ltm',
      label: 'Revenue Projection',
      tooltip: '',
      unit: '$',
    },
    annualExpenses: {
      key: 'annual_operating_expenses_total',
      label: 'Annual Expenses',
      tooltip:
        'The expected annual recurring expenses. The annual expenses typically include Short-term rental license fees, Home Owner Association (HOA) fees, and insurance.',
      subfields: [
        {
          key: 'management_fee',
          label: 'Management Fee',
          unit: isLegacy == 1 ? '%' : '$',
        },
        {
          key: 'property_tax',
          label: 'Property Tax',
          unit: isLegacy == 1 ? '%' : '$',
        },
        {
          key: 'lodging_tax',
          label: 'Lodgning Tax',
          unit: isLegacy == 1 ? '%' : '$',
        },
        {
          key: 'hoa_fee_annual',
          label: 'HOA Fee',
          unit: '$',
        },
        {
          key: 'maintenance_annual',
          label: 'Maintenance',
          unit: '$',
        },
        {
          key: 'insurance_annual',
          label: 'Insurance',
          unit: '$',
        },
        {
          key: 'electricity_annual',
          label: 'Electricity',
          unit: '$',
        },
        {
          key: 'wifi_annual',
          label: 'Wifi',
          unit: '$',
        },
        {
          key: 'gas_annual',
          label: 'Gas',
          unit: '$',
        },
        {
          key: 'others_annual',
          label: 'Others',
          unit: '$',
        },
      ],
      unit: '$',
    },
    propertyPrice: {
      key: 'property_price',
      label: 'Property Price',
      tooltip: `The property price of a property that you'd like to simulate profit for.`,
      unit: '$',
    },
    startupCosts: {
      key: 'startup_costs_total',
      label: 'Startup Costs',
      tooltip: `It's the cost that occurs only once to get started with your short-term rentals. The startup costs typically include refurbishment fee and closing costs.`,
      subfields: [
        {
          key: 'furnishing_cost',
          label: 'Home Furnishings',
          unit: '$',
        },
        {
          key: 'closing_cost',
          label: 'Closing Costs',
          unit: '$',
        },
      ],
      unit: '$',
    },
  };
};

export const managementCalInputKeys = {
  annualRevenue: {
    key: 'annual_revenue_ltm',
    label: 'Revenue Projection',
    tooltip: '',
    unit: '$',
  },
  annualExpenses: {
    key: 'annual_operating_expenses_total',
    label: 'Annual Expenses',
    tooltip:
      'The expected annual recurring expenses. The annual expenses typically include Short-term rental license fees, Home Owner Association (HOA) fees, and insurance.',
    subfields: [
      {
        key: 'management_fee',
        label: 'Management Fee',
        unit: '%',
      },
      {
        key: 'lodging_tax',
        label: 'Lodgning Tax',
        unit: '%',
      },
      {
        key: 'hoa_fee_annual',
        label: 'HOA Fee',
        unit: '$',
      },
      {
        key: 'maintenance_annual',
        label: 'Maintenance',
        unit: '$',
      },
      {
        key: 'insurance_annual',
        label: 'Insurance',
        unit: '$',
      },
      {
        key: 'electricity_annual',
        label: 'Electricity',
        unit: '$',
      },
      {
        key: 'wifi_annual',
        label: 'Wifi',
        unit: '$',
      },
      {
        key: 'gas_annual',
        label: 'Gas',
        unit: '$',
      },
      {
        key: 'others_annual',
        label: 'Others',
        unit: '$',
      },
    ],
    unit: '$',
  },
  ownerOccupiedDays: {
    key: 'owner_occupied_days',
    label: "Number of owner's occupied days",
    tooltip:
      'Number of days the property was occupied by the owner, making it unavailable for booking.',
    unit: '',
  },
};

export const Top10ManagerDummyData = [
  {
    id: 9802857,
    name: 'My Getaways',
    revenue: 2872414,
    listings: 80,
    image:
      'https://a0.muscache.com/im/pictures/prohost-api/Hosting-14710163/original/fd4a9550-4de3-4f45-a80e-aedbcfaab98b.jpeg?aki_policy=small',
    avgRating: 4.37,
  },
  {
    id: 183539480,
    name: 'Airhost For You',
    revenue: 1934068,
    listings: 77,
    image:
      'https://a0.muscache.com/im/pictures/prohost-api/Hosting-24750876/original/884969e7-3530-47e4-8877-55ac8bf63c23.jpeg?aki_policy=small',
    avgRating: 4.61,
  },
  {
    id: 116513439,
    name: 'Original Cottages Kent & Sussex',
    revenue: 1627675,
    listings: 22,
    image:
      'https://a0.muscache.com/im/pictures/prohost-api/Hosting-22543520/original/340c6105-15f4-4468-bd9e-c69784722a99.jpeg?aki_policy=small',
    avgRating: 3.27,
  },
  {
    id: 298960871,
    name: 'Blok-Brighton',
    revenue: 1093324,
    listings: 24,
    image:
      'https://a0.muscache.com/im/pictures/5a1e2b9d-f8fc-4c46-989b-cc88272102b0.jpg?aki_policy=small',
    avgRating: 4.7,
  },
  {
    id: 402695524,
    name: 'Francesca',
    revenue: 1031222,
    listings: 31,
    image:
      'https://a0.muscache.com/im/pictures/487053ed-efec-4c45-8d27-60d00031d47b.jpg?aki_policy=small',
    avgRating: 4.61,
  },
  {
    id: 96169037,
    name: 'Brighton Holiday Lets',
    revenue: 1009010,
    listings: 40,
    image:
      'https://a0.muscache.com/im/pictures/prohost-api/Hosting-15201823/original/4d457ff0-a33f-4881-bfaf-74da2bbe1c1c.jpeg?aki_policy=small',
    avgRating: 4.58,
  },
  {
    id: 44243335,
    name: 'Crown Gardens Holiday Homes',
    revenue: 823421,
    listings: 22,
    image:
      'https://a0.muscache.com/im/pictures/prohost-api/Hosting-8280138/original/28e94ac3-5f72-41b7-8d63-5a0e44c8a243.jpeg?aki_policy=small',
    avgRating: 3.45,
  },
  {
    id: 190150800,
    name: 'Creatick',
    revenue: 781499,
    listings: 30,
    image:
      'https://a0.muscache.com/im/pictures/63553543-8c09-4fd5-9289-1232afababea.jpg?aki_policy=small',
    avgRating: 4.57,
  },
  {
    id: 279714013,
    name: 'Terry',
    revenue: 754031,
    listings: 61,
    image:
      'https://a0.muscache.com/im/pictures/prohost-api/Hosting-37902650/original/83dc4bf2-8cc4-4771-a09f-31ed3959babb.jpeg?aki_policy=small',
    avgRating: 3.9,
  },
  {
    id: 394289502,
    name: 'Sharphaus',
    revenue: 681018,
    listings: 24,
    image:
      'https://a0.muscache.com/im/pictures/miso/Hosting-48924856/original/11686a59-7902-4a0f-991a-545c3b435d19.jpeg?aki_policy=small',
    avgRating: 4.04,
  },
];

// Sample Data for Insights Dashboard

export const sampleOccupancyRateData: OccupancyRate[] = [
  { date: '2020-09', occupancy_rate: 58 },
  { date: '2020-10', occupancy_rate: 58 },
  { date: '2020-11', occupancy_rate: 56 },
  { date: '2020-12', occupancy_rate: 54 },
  { date: '2021-01', occupancy_rate: 53 },
  { date: '2021-02', occupancy_rate: 54 },
  { date: '2021-03', occupancy_rate: 56 },
  { date: '2021-04', occupancy_rate: 62 },
  { date: '2021-05', occupancy_rate: 66 },
  { date: '2021-06', occupancy_rate: 68 },
  { date: '2021-07', occupancy_rate: 71 },
  { date: '2021-08', occupancy_rate: 71 },
];

export const sampleMedianNightlyRateData: ADR[] = [
  { date: '2020-09', adr: 168 },
  { date: '2020-10', adr: 170 },
  { date: '2020-11', adr: 169 },
  { date: '2020-12', adr: 172 },
  { date: '2021-01', adr: 170 },
  { date: '2021-02', adr: 172 },
  { date: '2021-03', adr: 180 },
  { date: '2021-04', adr: 189 },
  { date: '2021-05', adr: 201 },
  { date: '2021-06', adr: 212 },
  { date: '2021-07', adr: 216 },
  { date: '2021-08', adr: 222 },
];

export const sampleRevenueData: Revenue[] = [
  { date: '2020-09', revenue: 3158 },
  { date: '2020-10', revenue: 3214 },
  { date: '2020-11', revenue: 3082 },
  { date: '2020-12', revenue: 3065 },
  { date: '2021-01', revenue: 2992 },
  { date: '2021-02', revenue: 3075 },
  { date: '2021-03', revenue: 3296 },
  { date: '2021-04', revenue: 3659 },
  { date: '2021-05', revenue: 4171 },
  { date: '2021-06', revenue: 4580 },
  { date: '2021-07', revenue: 4962 },
  { date: '2021-08', revenue: 5154 },
];

export const sampleMarketTrendData = {
  '2018': 27,
  '2019': 26,
  '2020': 12,
  '2021': 13,
};

export const dummyPropertySizeBarGraphData: BarGraphData[] = [
  {
    keyShort: 'Studio',
    keyLong: 'Studio',
    value: 4,
  },
  {
    keyShort: '1',
    keyLong: '1 bedroom',
    value: 4,
  },
  {
    keyShort: '2',
    keyLong: '2 bedrooms',
    value: 11,
  },
  {
    keyShort: '3',
    keyLong: '3 bedrooms',
    value: 9,
  },
  {
    keyShort: '4',
    keyLong: '4 bedrooms',
    value: 14,
  },
  {
    keyShort: '5',
    keyLong: '5 bedrooms',
    value: 24,
  },
  {
    keyShort: '6+',
    keyLong: '6+ bedrooms',
    value: 31,
  },
  {
    keyShort: 'rooms',
    keyLong: 'private/hotel/shared rooms',
    value: 3,
  },
];

export const dummyPieChartData: PieChartData[] = [
  { name: 'Entire Home', value: 43, percentage: 43, legend: 'E' },
  { name: 'Condo', value: 17, percentage: 17, legend: 'C' },
  { name: 'Private Room', value: 12, percentage: 12, legend: 'P' },
  { name: 'Hotel Room', value: 24, percentage: 24, legend: 'H' },
  { name: 'Shared Room', value: 3, percentage: 3, legend: 'S' },
];

export const dummyBookingTypeBarGraphData: BarGraphData[] = [
  {
    keyLong: 'Multiple Nights',
    value: 55,
  },
  {
    keyLong: 'Single Night',
    value: 33,
  },
  {
    keyLong: 'Weekly',
    value: 7,
  },
  {
    keyLong: 'Mid-term',
    value: 4,
  },
];

export const dummyBookingLeadBarGraphData: BarGraphData[] = [
  {
    keyLong: 'Advanced',
    value: 74,
  },
  {
    keyLong: 'Normal',
    value: 20,
  },
  {
    keyLong: 'Last-minute',
    value: 6,
  },
];

export const sampleMarket = 'the city of brighton and hove';
// export const sampleEstimatorMarket = 'Sand Hill Road, Menlo Park, CA, USA';
// export const sampleEstimatorCenterCoord = { lat: 37.4209955, lng: -122.2071039 };
export const sampleDiscoveryAddress = 'Miami, FL, USA';

export const mapPadding = {
  bottom: 10,
  left: 10,
  right: 10,
  top: 10,
};

export const DYNAMIC_PRICING_ANALYTICS_MIXPANEL_TOKEN = 'f6e0ab2f76279e5f77ee98e743c2ca03';

export const timePreiodNumberNameMap = {
  100: 'All-History',
  12: '12-Months',
  6: '6-Months',
};

export const percentageNumberNameMap = {
  0.9: 'Top-10%',
  0.5: 'Top-50%',
  0.75: 'Top-25%',
};

export const FREE_MARKET_SEARCH_LIMIT = 3;
export const FREE_REPORT_CREATION_LIMIT = 10;

export const DOWNLOAD_CSV_LISTINGS_LTM_DATA = 'Individual listing’s LTM data';
export const DOWNLOAD_CSV_KEY_METRICS = 'Key Metrics by Property Size';
export const DISCOVERY_TOOL_VIDEO_TUTORIAL_LINK = 'https://youtu.be/qrMX_z5LXLU';

export const CLUSTER_POINTER_ZOOM_LEVEL_THRESHOLD = 12;

export const LEGACY_USER_DESCRIPTION_MAP = {
  property_investor: 'Property Investor',
  property_manager: 'Airbnb Host / Property Manager',
  tourism: 'Researcher / Government',
  unclassified: 'Others',
};

export const LEGACY_USER_CUSTOM_QUESTION_MAP = {
  property_investor: {
    question: 'How many properties will you purchase in the next 12 months?',
    options: {
      '1 - 5 properties': '1 - 5 properties',
      '5 - 20 properties': '5 - 20 properties',
      '20+ properties': '20+ properties',
    },
  },
  property_manager: {
    question: 'How many Airbnb listings do you currently manage?',
    options: {
      '0 listing': '0 listing',
      '1 - 5 listings': '1 - 5 listings',
      '5 - 20 listings': '5 - 20 listings',
      '20+ listings': '20+ listings',
    },
  },
};

export const USER_DESCRIPTION_MAP = {
  new_property_investor: "I'm thinking of starting an Airbnb business",
  property_investor: 'I already manage one or more Airbnb listings',
  property_manager: 'I help others start an Airbnb (consultant, realtor, property manager, etc.)',
  unclassified: 'Other (Please describe)',
};

export const USER_CUSTOM_QUESTION_MAP = {
  new_property_investor: {
    question: 'Where are you currently in your journey?',
    options: {
      market_research: 'Comparing the best markets to invest in',
      neighborhood_research: 'Comparing the best neighborhoods within a city',
      revenue_estimation: 'I have a property (or properties) in mind and want to estimate revenue',
      unclassified: 'Other (Please describe)',
    },
  },
};

export const secondUserDescriptionMap = {
  property_investor: {
    'How many properties will you purchase in the next 12 months?': [
      '1 - 5 properties',
      '5 - 20 properties',
      '20+ properties',
    ],
  },
  property_manager: {
    'How many Airbnb listings do you currently manage?': [
      '0 listing',
      '1 - 5 listings',
      '5 - 20 listings',
      '20+ listings',
    ],
  },
};

export const daysInMonth = (isLeapYear: boolean, monthObject: boolean = false) => {
  if (monthObject) {
    return {
      january: 31,
      february: isLeapYear ? 29 : 28,
      march: 31,
      april: 30,
      may: 31,
      june: 30,
      july: 31,
      august: 31,
      september: 30,
      october: 31,
      november: 30,
      december: 31,
    };
  }
  return [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
};

export const fuseSearchOptions = {
  includeMatchers: true,
  useExtendedSearch: true,
  includeScore: true,
  shouldSort: true,
  findAllMatches: true,
  keys: [
    {
      name: 'district',
      weight: 10,
    },
    {
      name: 'city',
      weight: 0.5,
    },
    {
      name: 'country',
      weight: 0.5,
    },
  ],
};

export const TOP_BANNER_PADDING = '60px';
export const TOP_BANNER_PADDING_MOBILE = '100px';
export const AIRBTICS_PRO_BANNER_LOCALSTORAGE_VARIABLE = 'is-top-banner-airbtics-pro-shown';

export const countryListWithCode = [
  { code: 'AF', label: 'Afghanistan ' },
  { code: 'AL', label: 'Albania ' },
  { code: 'DZ', label: 'Algeria ' },
  { code: 'AS', label: 'American Samoa ' },
  { code: 'AD', label: 'Andorra ' },
  { code: 'AO', label: 'Angola ' },
  { code: 'AI', label: 'Anguilla ' },
  { code: 'AQ', label: 'Antarctica ' },
  { code: 'AG', label: 'Antigua and Barbuda ' },
  { code: 'AR', label: 'Argentina ' },
  { code: 'AM', label: 'Armenia ' },
  { code: 'AW', label: 'Aruba ' },
  { code: 'AU', label: 'Australia ' },
  { code: 'AT', label: 'Austria ' },
  { code: 'AZ', label: 'Azerbaijan ' },
  { code: 'BS', label: 'Bahamas ' },
  { code: 'BH', label: 'Bahrain ' },
  { code: 'BD', label: 'Bangladesh ' },
  { code: 'BB', label: 'Barbados ' },
  { code: 'BY', label: 'Belarus ' },
  { code: 'BE', label: 'Belgium ' },
  { code: 'BZ', label: 'Belize ' },
  { code: 'BJ', label: 'Benin ' },
  { code: 'BM', label: 'Bermuda ' },
  { code: 'BT', label: 'Bhutan ' },
  { code: 'BO', label: 'Bolivia (Plurinational State of) ' },
  { code: 'BQ', label: 'Bonaire, Sint Eustatius and Saba ' },
  { code: 'BA', label: 'Bosnia and Herzegovina ' },
  { code: 'BW', label: 'Botswana ' },
  { code: 'BV', label: 'Bouvet Island ' },
  { code: 'BR', label: 'Brazil ' },
  { code: 'IO', label: 'British Indian Ocean Territory ' },
  { code: 'BN', label: 'Brunei Darussalam ' },
  { code: 'BG', label: 'Bulgaria ' },
  { code: 'BF', label: 'Burkina Faso ' },
  { code: 'BI', label: 'Burundi ' },
  { code: 'CV', label: 'Cabo Verde ' },
  { code: 'KH', label: 'Cambodia ' },
  { code: 'CM', label: 'Cameroon ' },
  { code: 'CA', label: 'Canada ' },
  { code: 'KY', label: 'Cayman Islands ' },
  { code: 'CF', label: 'Central African Republic ' },
  { code: 'TD', label: 'Chad ' },
  { code: 'CL', label: 'Chile ' },
  { code: 'CN', label: 'China ' },
  { code: 'CX', label: 'Christmas Island ' },
  { code: 'CC', label: 'Cocos (Keeling) Islands ' },
  { code: 'CO', label: 'Colombia ' },
  { code: 'KM', label: 'Comoros ' },
  { code: 'CD', label: 'Congo (the Democratic Republic of the) ' },
  { code: 'CG', label: 'Congo ' },
  { code: 'CK', label: 'Cook Islands ' },
  { code: 'CR', label: 'Costa Rica ' },
  { code: 'HR', label: 'Croatia ' },
  { code: 'CU', label: 'Cuba ' },
  { code: 'CW', label: 'Curaçao ' },
  { code: 'CY', label: 'Cyprus ' },
  { code: 'CZ', label: 'Czechia ' },
  { code: 'CI', label: "Côte d'Ivoire " },
  { code: 'DK', label: 'Denmark ' },
  { code: 'DJ', label: 'Djibouti ' },
  { code: 'DM', label: 'Dominica ' },
  { code: 'DO', label: 'Dominican Republic ' },
  { code: 'EC', label: 'Ecuador ' },
  { code: 'EG', label: 'Egypt ' },
  { code: 'SV', label: 'El Salvador ' },
  { code: 'GQ', label: 'Equatorial Guinea ' },
  { code: 'ER', label: 'Eritrea ' },
  { code: 'EE', label: 'Estonia ' },
  { code: 'SZ', label: 'Eswatini ' },
  { code: 'ET', label: 'Ethiopia ' },
  { code: 'FK', label: 'Falkland Islands  [Malvinas] ' },
  { code: 'FO', label: 'Faroe Islands ' },
  { code: 'FJ', label: 'Fiji ' },
  { code: 'FI', label: 'Finland ' },
  { code: 'FR', label: 'France ' },
  { code: 'GF', label: 'French Guiana ' },
  { code: 'PF', label: 'French Polynesia ' },
  { code: 'TF', label: 'French Southern Territories ' },
  { code: 'GA', label: 'Gabon ' },
  { code: 'GM', label: 'Gambia ' },
  { code: 'GE', label: 'Georgia ' },
  { code: 'DE', label: 'Germany ' },
  { code: 'GH', label: 'Ghana ' },
  { code: 'GI', label: 'Gibraltar ' },
  { code: 'GR', label: 'Greece ' },
  { code: 'GL', label: 'Greenland ' },
  { code: 'GD', label: 'Grenada ' },
  { code: 'GP', label: 'Guadeloupe ' },
  { code: 'GU', label: 'Guam ' },
  { code: 'GT', label: 'Guatemala ' },
  { code: 'GG', label: 'Guernsey ' },
  { code: 'GN', label: 'Guinea ' },
  { code: 'GW', label: 'Guinea-Bissau ' },
  { code: 'GY', label: 'Guyana ' },
  { code: 'HT', label: 'Haiti ' },
  { code: 'HM', label: 'Heard Island and McDonald Islands ' },
  { code: 'VA', label: 'Holy See ' },
  { code: 'HN', label: 'Honduras ' },
  { code: 'HK', label: 'Hong Kong ' },
  { code: 'HU', label: 'Hungary ' },
  { code: 'IS', label: 'Iceland ' },
  { code: 'IN', label: 'India ' },
  { code: 'ID', label: 'Indonesia ' },
  { code: 'IR', label: 'Iran (Islamic Republic of) ' },
  { code: 'IQ', label: 'Iraq ' },
  { code: 'IE', label: 'Ireland ' },
  { code: 'IM', label: 'Isle of Man ' },
  { code: 'IL', label: 'Israel ' },
  { code: 'IT', label: 'Italy ' },
  { code: 'JM', label: 'Jamaica ' },
  { code: 'JP', label: 'Japan ' },
  { code: 'JE', label: 'Jersey ' },
  { code: 'JO', label: 'Jordan ' },
  { code: 'KZ', label: 'Kazakhstan ' },
  { code: 'KE', label: 'Kenya ' },
  { code: 'KI', label: 'Kiribati ' },
  { code: 'KP', label: "Korea (the Democratic People's Republic of) " },
  { code: 'KR', label: 'Korea (the Republic of) ' },
  { code: 'KW', label: 'Kuwait ' },
  { code: 'KG', label: 'Kyrgyzstan ' },
  { code: 'LA', label: "Lao People's Democratic Republic " },
  { code: 'LV', label: 'Latvia ' },
  { code: 'LB', label: 'Lebanon ' },
  { code: 'LS', label: 'Lesotho ' },
  { code: 'LR', label: 'Liberia ' },
  { code: 'LY', label: 'Libya ' },
  { code: 'LI', label: 'Liechtenstein ' },
  { code: 'LT', label: 'Lithuania ' },
  { code: 'LU', label: 'Luxembourg ' },
  { code: 'MO', label: 'Macao ' },
  { code: 'MG', label: 'Madagascar ' },
  { code: 'MW', label: 'Malawi ' },
  { code: 'MY', label: 'Malaysia ' },
  { code: 'MV', label: 'Maldives ' },
  { code: 'ML', label: 'Mali ' },
  { code: 'MT', label: 'Malta ' },
  { code: 'MH', label: 'Marshall Islands ' },
  { code: 'MQ', label: 'Martinique ' },
  { code: 'MR', label: 'Mauritania ' },
  { code: 'MU', label: 'Mauritius ' },
  { code: 'YT', label: 'Mayotte ' },
  { code: 'MX', label: 'Mexico ' },
  { code: 'FM', label: 'Micronesia (Federated States of) ' },
  { code: 'MD', label: 'Moldova (the Republic of) ' },
  { code: 'MC', label: 'Monaco ' },
  { code: 'MN', label: 'Mongolia ' },
  { code: 'ME', label: 'Montenegro ' },
  { code: 'MS', label: 'Montserrat ' },
  { code: 'MA', label: 'Morocco ' },
  { code: 'MZ', label: 'Mozambique ' },
  { code: 'MM', label: 'Myanmar ' },
  { code: 'NA', label: 'Namibia ' },
  { code: 'NR', label: 'Nauru ' },
  { code: 'NP', label: 'Nepal ' },
  { code: 'NL', label: 'Netherlands ' },
  { code: 'NC', label: 'New Caledonia ' },
  { code: 'NZ', label: 'New Zealand ' },
  { code: 'NI', label: 'Nicaragua ' },
  { code: 'NE', label: 'Niger ' },
  { code: 'NG', label: 'Nigeria ' },
  { code: 'NU', label: 'Niue ' },
  { code: 'NF', label: 'Norfolk Island ' },
  { code: 'MP', label: 'Northern Mariana Islands ' },
  { code: 'NO', label: 'Norway ' },
  { code: 'OM', label: 'Oman ' },
  { code: 'PK', label: 'Pakistan ' },
  { code: 'PW', label: 'Palau ' },
  { code: 'PS', label: 'Palestine ' },
  { code: 'PA', label: 'Panama ' },
  { code: 'PG', label: 'Papua New Guinea ' },
  { code: 'PY', label: 'Paraguay ' },
  { code: 'PE', label: 'Peru ' },
  { code: 'PH', label: 'Philippines ' },
  { code: 'PN', label: 'Pitcairn ' },
  { code: 'PL', label: 'Poland ' },
  { code: 'PT', label: 'Portugal ' },
  { code: 'PR', label: 'Puerto Rico ' },
  { code: 'QA', label: 'Qatar ' },
  { code: 'MK', label: 'Republic of North Macedonia ' },
  { code: 'RO', label: 'Romania ' },
  { code: 'RU', label: 'Russian Federation ' },
  { code: 'RW', label: 'Rwanda ' },
  { code: 'RE', label: 'Réunion ' },
  { code: 'BL', label: 'Saint Barthélemy ' },
  { code: 'SH', label: 'Saint Helena, Ascension and Tristan da Cunha ' },
  { code: 'KN', label: 'Saint Kitts and Nevis ' },
  { code: 'LC', label: 'Saint Lucia ' },
  { code: 'MF', label: 'Saint Martin (French part) ' },
  { code: 'PM', label: 'Saint Pierre and Miquelon ' },
  { code: 'VC', label: 'Saint Vincent and the Grenadines ' },
  { code: 'WS', label: 'Samoa ' },
  { code: 'SM', label: 'San Marino ' },
  { code: 'ST', label: 'Sao Tome and Principe ' },
  { code: 'SA', label: 'Saudi Arabia ' },
  { code: 'SN', label: 'Senegal ' },
  { code: 'RS', label: 'Serbia ' },
  { code: 'SC', label: 'Seychelles ' },
  { code: 'SL', label: 'Sierra Leone ' },
  { code: 'SG', label: 'Singapore ' },
  { code: 'SX', label: 'Sint Maarten (Dutch part) ' },
  { code: 'SK', label: 'Slovakia ' },
  { code: 'SI', label: 'Slovenia ' },
  { code: 'SB', label: 'Solomon Islands ' },
  { code: 'SO', label: 'Somalia ' },
  { code: 'ZA', label: 'South Africa ' },
  { code: 'GS', label: 'South Georgia and the South Sandwich Islands ' },
  { code: 'SS', label: 'South Sudan ' },
  { code: 'ES', label: 'Spain ' },
  { code: 'LK', label: 'Sri Lanka ' },
  { code: 'SD', label: 'Sudan ' },
  { code: 'SR', label: 'Suriname ' },
  { code: 'SJ', label: 'Svalbard and Jan Mayen ' },
  { code: 'SE', label: 'Sweden ' },
  { code: 'CH', label: 'Switzerland ' },
  { code: 'SY', label: 'Syrian Arab Republic ' },
  { code: 'TW', label: 'Taiwan ' },
  { code: 'TJ', label: 'Tajikistan ' },
  { code: 'TZ', label: 'Tanzania, United Republic of ' },
  { code: 'TH', label: 'Thailand ' },
  { code: 'TL', label: 'Timor-Leste ' },
  { code: 'TG', label: 'Togo ' },
  { code: 'TK', label: 'Tokelau ' },
  { code: 'TO', label: 'Tonga ' },
  { code: 'TT', label: 'Trinidad and Tobago ' },
  { code: 'TN', label: 'Tunisia ' },
  { code: 'TR', label: 'Turkey ' },
  { code: 'TM', label: 'Turkmenistan' },
  { code: 'TC', label: 'Turks and Caicos Islands ' },
  { code: 'TV', label: 'Tuvalu ' },
  { code: 'UG', label: 'Uganda ' },
  { code: 'UA', label: 'Ukraine ' },
  { code: 'AE', label: 'United Arab Emirates' },
  { code: 'GB', label: 'United Kingdom' },
  { code: 'UM', label: 'United States Minor Outlying Islands ' },
  { code: 'US', label: 'United States ' },
  { code: 'UY', label: 'Uruguay' },
  { code: 'UZ', label: 'Uzbekistan' },
  { code: 'VU', label: 'Vanuatu' },
  { code: 'VE', label: 'Venezuela (Bolivarian Republic of)' },
  { code: 'VN', label: 'Viet Nam' },
  { code: 'VG', label: 'Virgin Islands (British) ' },
  { code: 'VI', label: 'Virgin Islands (U.S.) ' },
  { code: 'WF', label: 'Wallis and Futuna ' },
  { code: 'EH', label: 'Western Sahara' },
  { code: 'YE', label: 'Yemen ' },
  { code: 'ZM', label: 'Zambia ' },
  { code: 'ZW', label: 'Zimbabwe ' },
  { code: 'AX', label: 'Åland Islands ' },
];

export const countryNameCodeMapFromDB = {
  andorra: 'AD',
  'united-arab-emirates': 'AE',
  afghanistan: 'AF',
  'antigua-and-barbuda': 'AG',
  anguilla: 'AI',
  albania: 'AL',
  armenia: 'AM',
  'netherlands-antilles': 'AN',
  angola: 'AO',
  argentina: 'AR',
  'american-samoa': 'AS',
  austria: 'AT',
  australia: 'AU',
  aruba: 'AW',
  'åland-islands': 'AX',
  azerbaijan: 'AZ',
  'bosnia-and-herzegovina': 'BA',
  barbados: 'BB',
  bangladesh: 'BD',
  belgium: 'BE',
  'burkina-faso': 'BF',
  bulgaria: 'BG',
  bahrain: 'BH',
  burundi: 'BI',
  benin: 'BJ',
  'st.-barthélemy': 'BL',
  bermuda: 'BM',
  brunei: 'BN',
  bolivia: 'BO',
  brazil: 'BR',
  bahamas: 'BS',
  bhutan: 'BT',
  botswana: 'BW',
  belarus: 'BY',
  belize: 'BZ',
  canada: 'CA',
  'congo-the-democratic-republic-of-the': 'CD',
  'central-african-republic': 'CF',
  congo: 'CG',
  switzerland: 'CH',
  "cote-d'ivoire": 'CI',
  'cook-islands': 'CK',
  chile: 'CL',
  cameroon: 'CM',
  china: 'CN',
  columbia: 'CO',
  'costa-rica': 'CR',
  cuba: 'CU',
  'cape-verde': 'CV',
  curaçao: 'CW',
  'christmas-island': 'CX',
  cyprus: 'CY',
  czechia: 'CZ',
  germany: 'DE',
  denmark: 'DK',
  dominica: 'DM',
  'dominican-republic': 'DO',
  algeria: 'DZ',
  ecuador: 'EC',
  estonia: 'EE',
  egypt: 'EG',
  'western-sahara': 'EH',
  eritrea: 'ER',
  spain: 'ES',
  ethiopia: 'ET',
  finland: 'FI',
  fiji: 'FJ',
  'micronesia-federated-states-of': 'FM',
  'faroe-islands': 'FO',
  france: 'FR',
  gabon: 'GA',
  'united-kingdom': 'GB',
  grenada: 'GD',
  georgia: 'GE',
  'french-guiana': 'GF',
  guernsey: 'GG',
  ghana: 'GH',
  gibraltar: 'GI',
  greenland: 'GL',
  gambia: 'GM',
  guinea: 'GN',
  guadeloupe: 'GP',
  greece: 'GR',
  guatemala: 'GT',
  guam: 'GU',
  'guinea-bissau': 'GW',
  guyana: 'GY',
  'hong-kong': 'HK',
  honduras: 'HN',
  croatia: 'HR',
  haiti: 'HT',
  hungary: 'HU',
  indonesia: 'ID',
  ireland: 'IE',
  israel: 'IL',
  'isle-of-man': 'IM',
  india: 'IN',
  iraq: 'IQ',
  iceland: 'IS',
  italy: 'IT',
  jersey: 'JE',
  jamaica: 'JM',
  jordan: 'JO',
  japan: 'JP',
  kenya: 'KE',
  kyrgyzstan: 'KG',
  cambodia: 'KH',
  comoros: 'KM',
  'saint-kitts-and-nevis': 'KN',
  'south-korea': 'KR',
  kuwait: 'KW',
  'cayman-islands': 'KY',
  kazakhstan: 'KZ',
  laos: 'LA',
  lebanon: 'LB',
  'saint-lucia': 'LC',
  liechtenstein: 'LI',
  'sri-lanka': 'LK',
  lesotho: 'LS',
  lithuania: 'LT',
  luxembourg: 'LU',
  latvia: 'LV',
  'libyan-arab-jamahiriya': 'LY',
  morocco: 'MA',
  monaco: 'MC',
  'moldova-republic-of': 'MD',
  montenegro: 'ME',
  madagascar: 'MG',
  'macedonia-the-former-yugoslav-republic-of': 'MK',
  mali: 'ML',
  myanmar: 'MM',
  mongolia: 'MN',
  macao: 'MO',
  martinique: 'MQ',
  mauritania: 'MR',
  malta: 'MT',
  mauritius: 'MU',
  maldives: 'MV',
  malawi: 'MW',
  mexico: 'MX',
  malaysia: 'MY',
  mozambique: 'MZ',
  namibia: 'NA',
  'new-caledonia': 'NC',
  niger: 'NE',
  'norfolk-island': 'NF',
  nigeria: 'NG',
  nicaragua: 'NI',
  netherlands: 'NL',
  norway: 'NO',
  nepal: 'NP',
  'new-zealand': 'NZ',
  oman: 'OM',
  panama: 'PA',
  peru: 'PE',
  'french-polynesia': 'PF',
  'papua-new-guinea': 'PG',
  philippines: 'PH',
  pakistan: 'PK',
  poland: 'PL',
  'puerto-rico': 'PR',
  'palestinian-territory-occupied': 'PS',
  portugal: 'PT',
  palau: 'PW',
  paraguay: 'PY',
  qatar: 'QA',
  réunion: 'RE',
  romania: 'RO',
  serbia: 'RS',
  russia: 'RU',
  rwanda: 'RW',
  'saudi-arabia': 'SA',
  'solomon-islands': 'SB',
  seychelles: 'SC',
  sudan: 'SD',
  sweden: 'SE',
  singapore: 'SG',
  'saint-helena': 'SH',
  slovenia: 'SI',
  'svalbard-and-jan-mayen': 'SJ',
  slovakia: 'SK',
  'sierra-leone': 'SL',
  senegal: 'SN',
  somalia: 'SO',
  suriname: 'SR',
  'sao-tome-and-principe': 'ST',
  'el-salvador': 'SV',
  'sint-maarten': 'SX',
  swaziland: 'SZ',
  'turks-and-caicos-islands': 'TC',
  togo: 'TG',
  thailand: 'TH',
  tajikistan: 'TJ',
  'timor-leste': 'TL',
  turkmenistan: 'TM',
  tunisia: 'TN',
  tonga: 'TO',
  turkey: 'TR',
  'trinidad-and-tobago': 'TT',
  tuvalu: 'TV',
  taiwan: 'TW',
  tanzania: 'TZ',
  ukraine: 'UA',
  uganda: 'UG',
  'united-states': 'US',
  uruguay: 'UY',
  uzbekistan: 'UZ',
  'saint-vincent-and-the-grenadines': 'VC',
  venezuela: 'VE',
  'virgin-islands-british': 'VG',
  'virgin-islands-u.s.': 'VI',
  vietnam: 'VN',
  vanuatu: 'VU',
  'wallis-and-futuna': 'WF',
  samoa: 'WS',
  mayotte: 'YT',
  'south-africa': 'ZA',
  zambia: 'ZM',
  zimbabwe: 'ZW',
};

export const AIRBTICS_PRO_PAYMENT_LINK_US = 'https://buy.stripe.com/dR64iN80Q2l54483dO';
export const AIRBTICS_PRO_PAYMENT_LINK_UK = 'https://buy.stripe.com/00geXr6WMcZJ7gkeWx';
export const AIRBTICS_PRO_PAYMENT_LINK_AU = 'https://buy.stripe.com/aEUg1v0yo8Jt7gk4hV';
export const AIRBTICS_PRO_PAYMENT_LINK_CA = 'https://buy.stripe.com/bIY9D7dlaaRB8ko7u6';

export const US_AIRBNB_STATISTICS_DATA_URL =
  'https://airbtics-resource.s3.us-east-2.amazonaws.com/us_marrkets_top_city_data.csv';
export const US_REAL_ESTATE_ANALYSIS_TABLE_DATA_URL =
  'https://airbtics-resource.s3.us-east-2.amazonaws.com/real_estate_investability-5_years_trend.csv';

export const UK_AIRBNB_STATISTICS_DATA_URL =
  'https://airbtics-resource.s3.us-east-2.amazonaws.com/uk_markets_top_city.csv';
export const UK_REAL_ESTATE_ANALYSIS_TABLE_DATA_URL =
  'https://airbtics-resource.s3.us-east-2.amazonaws.com/uk_real_estate_investability-5_years_trend.csv';

export const CA_AIRBNB_STATISTICS_DATA_URL =
  'https://airbtics-resource.s3.us-east-2.amazonaws.com/ca_markets_top_city.csv';
export const CA_REAL_ESTATE_ANALYSIS_TABLE_DATA_URL =
  'https://airbtics-resource.s3.us-east-2.amazonaws.com/ca_real_estate_investability-5_years_trend.csv';

export const AU_AIRBNB_STATISTICS_DATA_URL =
  'https://airbtics-resource.s3.us-east-2.amazonaws.com/au_markets_top_city.csv';
export const AU_REAL_ESTATE_ANALYSIS_TABLE_DATA_URL =
  'https://airbtics-resource.s3.us-east-2.amazonaws.com/au_real_estate_investability-5_years_trend.csv';

export const countryWiseAirbticsProTableLinks = {
  US: {
    statistics_data: US_AIRBNB_STATISTICS_DATA_URL,
    real_estate_analysis_data: US_REAL_ESTATE_ANALYSIS_TABLE_DATA_URL,
  },
  UK: {
    statistics_data: UK_AIRBNB_STATISTICS_DATA_URL,
    real_estate_analysis_data: UK_REAL_ESTATE_ANALYSIS_TABLE_DATA_URL,
  },
  CA: {
    statistics_data: CA_AIRBNB_STATISTICS_DATA_URL,
    real_estate_analysis_data: CA_REAL_ESTATE_ANALYSIS_TABLE_DATA_URL,
  },
  AU: {
    statistics_data: AU_AIRBNB_STATISTICS_DATA_URL,
    real_estate_analysis_data: AU_REAL_ESTATE_ANALYSIS_TABLE_DATA_URL,
  },
};

export const countryWiseAirbticsProImgLinkObj = {
  US: AirbticsProImageUS,
  UK: AirbticsProImageUK,
  CA: AirbticsProImageCA,
  AU: AirbticsProImageAU,
};

export const airbticsProCountries = { USA: 'US', CANADA: 'CA', AUSTRALIA: 'AU', UK: 'UK' };

export const countryWiseAirbticsProPaymentLinkObj = {
  US: AIRBTICS_PRO_PAYMENT_LINK_US,
  UK: AIRBTICS_PRO_PAYMENT_LINK_UK,
  CA: AIRBTICS_PRO_PAYMENT_LINK_CA,
  AU: AIRBTICS_PRO_PAYMENT_LINK_AU,
};

export const shortMonthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const mlaMonthsShort = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'June',
  'July',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

export const airbnbManageYourSpaceUrls = [
  'https://www.airbnb.ae/manage-your-space/',
  'https://www.airbnb.al/manage-your-space/',
  'https://www.airbnb.am/manage-your-space/',
  'https://www.airbnb.at/manage-your-space/',
  'https://www.airbnb.az/manage-your-space/',
  'https://www.airbnb.ba/manage-your-space/',
  'https://www.airbnb.be/manage-your-space/',
  'https://www.airbnb.ca/manage-your-space/',
  'https://www.airbnb.cat/manage-your-space/',
  'https://www.airbnb.ch/manage-your-space/',
  'https://www.airbnb.co.in/manage-your-space/',
  'https://www.airbnb.cl/manage-your-space/',
  'https://www.airbnb.cn/manage-your-space/',
  'https://www.airbnb.co.cr/manage-your-space/',
  'https://www.airbnb.co.id/manage-your-space/',
  'https://www.airbnb.co.il/manage-your-space/',
  'https://www.airbnb.co.kr/manage-your-space/',
  'https://www.airbnb.com/manage-your-space/',
  'https://www.airbnb.com.ar/manage-your-space/',
  'https://www.airbnb.com.au/manage-your-space/',
  'https://www.airbnb.com.bo/manage-your-space/',
  'https://www.airbnb.com.br/manage-your-space/',
  'https://www.airbnb.com.bz/manage-your-space/',
  'https://www.airbnb.com.co/manage-your-space/',
  'https://www.airbnb.com.ec/manage-your-space/',
  'https://www.airbnb.com.ee/manage-your-space/',
  'https://www.airbnb.com.gt/manage-your-space/',
  'https://www.airbnb.com.hk/manage-your-space/',
  'https://www.airbnb.com.hn/manage-your-space/',
  'https://www.airbnb.com.hr/manage-your-space/',
  'https://www.airbnb.com.kh/manage-your-space/',
  'https://www.airbnb.com.mt/manage-your-space/',
  'https://www.airbnb.com.my/manage-your-space/',
  'https://www.airbnb.com.ni/manage-your-space/',
  'https://www.airbnb.com.pa/manage-your-space/',
  'https://www.airbnb.com.pe/manage-your-space/',
  'https://www.airbnb.com.ph/manage-your-space/',
  'https://www.airbnb.com.py/manage-your-space/',
  'https://www.airbnb.com.ro/manage-your-space/',
  'https://www.airbnb.com.sg/manage-your-space/',
  'https://www.airbnb.com.sv/manage-your-space/',
  'https://www.airbnb.com.tr/manage-your-space/',
  'https://www.airbnb.com.tw/manage-your-space/',
  'https://www.airbnb.com.ua/manage-your-space/',
  'https://www.airbnb.com.vn/manage-your-space/',
  'https://www.airbnb.co.nz/manage-your-space/',
  'https://www.airbnb.co.uk/manage-your-space/',
  'https://www.airbnb.co.ve/manage-your-space/',
  'https://www.airbnb.co.za/manage-your-space/',
  'https://www.airbnb.cz/manage-your-space/',
  'https://www.airbnb.de/manage-your-space/',
  'https://www.airbnb.dk/manage-your-space/',
  'https://www.airbnb.es/manage-your-space/',
  'https://www.airbnb.fi/manage-your-space/',
  'https://www.airbnb.fr/manage-your-space/',
  'https://www.airbnb.gr/manage-your-space/',
  'https://www.airbnb.hu/manage-your-space/',
  'https://www.airbnb.ie/manage-your-space/',
  'https://www.airbnb.is/manage-your-space/',
  'https://www.airbnb.it/manage-your-space/',
  'https://www.airbnb.jp/manage-your-space/',
  'https://www.airbnb.la/manage-your-space/',
  'https://www.airbnb.lt/manage-your-space/',
  'https://www.airbnb.lu/manage-your-space/',
  'https://www.airbnb.lv/manage-your-space/',
  'https://www.airbnb.me/manage-your-space/',
  'https://www.airbnb.mx/manage-your-space/',
  'https://www.airbnb.nl/manage-your-space/',
  'https://www.airbnb.no/manage-your-space/',
  'https://www.airbnb.pl/manage-your-space/',
  'https://www.airbnb.pt/manage-your-space/',
  'https://www.airbnb.rs/manage-your-space/',
  'https://www.airbnb.ru/manage-your-space/',
  'https://www.airbnb.se/manage-your-space/',
  'https://www.airbnb.si/manage-your-space/',
];

export const WORDPRESS_TO_DISCOVERY_KEY = 'wpy4Zmpg4eCm5WcpA0wp';

export const amenitiesObject = {
  beachfront: 'Beachfront',
  amazing_views: 'Amazing Views',
  pool: 'Pool',
  hot_tub: 'Hot Tub',
  parking: 'Parking',
  pets: 'Pet Friendly',
  ac: 'AC',
  heating: 'Heating',
  breakfast: 'Breakfast',
  dryer: 'Dryer',
  washer: 'Washer',
  gym: 'Gym',
  kitchen: 'Kitchen',
  tv: 'TV',
  wifi: 'WiFi',
  bbq_grill: 'BBQ Grill',
  fireplace: 'Fireplace',
};

export const mainKpiOccupancyDummyData = [
  {
    '2021': {
      occupancy_rate25: 34,
      occupancy_rate50: 60,
      occupancy_rate75: 92,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 28,
      occupancy_rate50: 55,
      occupancy_rate75: 87,
      occupancy_rate90: 100,
    },
    month: 'Nov',
    LTMData: {
      occupancy_rate25: 28,
      occupancy_rate50: 55,
      occupancy_rate75: 87,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 34,
      occupancy_rate50: 60,
      occupancy_rate75: 92,
      occupancy_rate90: 100,
    },
    latestYear: 2022,
    previousYear: 2021,
    monthYear: 'Nov,22',
  },
  {
    '2021': {
      occupancy_rate25: 31,
      occupancy_rate50: 60,
      occupancy_rate75: 89,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 42,
      occupancy_rate50: 65,
      occupancy_rate75: 92,
      occupancy_rate90: 100,
    },
    month: 'Dec',
    LTMData: {
      occupancy_rate25: 42,
      occupancy_rate50: 65,
      occupancy_rate75: 92,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 31,
      occupancy_rate50: 60,
      occupancy_rate75: 89,
      occupancy_rate90: 100,
    },
    latestYear: 2022,
    previousYear: 2021,
    monthYear: 'Dec,22',
  },
  {
    '2021': {
      occupancy_rate25: null,
      occupancy_rate50: 60,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 28,
      occupancy_rate50: 55,
      occupancy_rate75: 86,
      occupancy_rate90: 100,
    },
    '2023': {
      occupancy_rate25: 20,
      occupancy_rate50: 46,
      occupancy_rate75: 80,
      occupancy_rate90: 100,
    },
    month: 'Jan',
    LTMData: {
      occupancy_rate25: 20,
      occupancy_rate50: 46,
      occupancy_rate75: 80,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 28,
      occupancy_rate50: 55,
      occupancy_rate75: 86,
      occupancy_rate90: 100,
    },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Jan,23',
  },
  {
    '2021': {
      occupancy_rate25: 22,
      occupancy_rate50: 56,
      occupancy_rate75: 87,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 37,
      occupancy_rate50: 65,
      occupancy_rate75: 93,
      occupancy_rate90: 100,
    },
    '2023': {
      occupancy_rate25: 34,
      occupancy_rate50: 60,
      occupancy_rate75: 84,
      occupancy_rate90: 100,
    },
    month: 'Feb',
    LTMData: {
      occupancy_rate25: 34,
      occupancy_rate50: 60,
      occupancy_rate75: 84,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 37,
      occupancy_rate50: 65,
      occupancy_rate75: 93,
      occupancy_rate90: 100,
    },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Feb,23',
  },
  {
    '2021': {
      occupancy_rate25: 19,
      occupancy_rate50: 51,
      occupancy_rate75: 89,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 29,
      occupancy_rate50: 60,
      occupancy_rate75: 92,
      occupancy_rate90: 100,
    },
    '2023': {
      occupancy_rate25: 30,
      occupancy_rate50: 56,
      occupancy_rate75: 84,
      occupancy_rate90: 100,
    },
    month: 'Mar',
    LTMData: {
      occupancy_rate25: 30,
      occupancy_rate50: 56,
      occupancy_rate75: 84,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 29,
      occupancy_rate50: 60,
      occupancy_rate75: 92,
      occupancy_rate90: 100,
    },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Mar,23',
  },
  {
    '2021': {
      occupancy_rate25: 40,
      occupancy_rate50: 72,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 56,
      occupancy_rate50: 80,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2023': {
      occupancy_rate25: 48,
      occupancy_rate50: 74,
      occupancy_rate75: 97,
      occupancy_rate90: 100,
    },
    month: 'Apr',
    LTMData: {
      occupancy_rate25: 48,
      occupancy_rate50: 74,
      occupancy_rate75: 97,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 56,
      occupancy_rate50: 80,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Apr,23',
  },
  {
    '2021': {
      occupancy_rate25: 27,
      occupancy_rate50: 55,
      occupancy_rate75: 86,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 48,
      occupancy_rate50: 74,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2023': {
      occupancy_rate25: 40,
      occupancy_rate50: 65,
      occupancy_rate75: 91,
      occupancy_rate90: 100,
    },
    month: 'May',
    LTMData: {
      occupancy_rate25: 40,
      occupancy_rate50: 65,
      occupancy_rate75: 91,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 48,
      occupancy_rate50: 74,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'May,23',
  },
  {
    '2021': {
      occupancy_rate25: 50,
      occupancy_rate50: 80,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 51,
      occupancy_rate50: 80,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2023': {
      occupancy_rate25: 49,
      occupancy_rate50: 76,
      occupancy_rate75: 99,
      occupancy_rate90: 100,
    },
    month: 'Jun',
    LTMData: {
      occupancy_rate25: 49,
      occupancy_rate50: 76,
      occupancy_rate75: 99,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 51,
      occupancy_rate50: 80,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Jun,23',
  },
  {
    '2021': {
      occupancy_rate25: 81,
      occupancy_rate50: 100,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 83,
      occupancy_rate50: 100,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2023': {
      occupancy_rate25: 68,
      occupancy_rate50: 92,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    month: 'Jul',
    LTMData: {
      occupancy_rate25: 68,
      occupancy_rate50: 92,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 83,
      occupancy_rate50: 100,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Jul,23',
  },
  {
    '2021': {
      occupancy_rate25: 85,
      occupancy_rate50: 100,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 60,
      occupancy_rate50: 87,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2023': {
      occupancy_rate25: 60,
      occupancy_rate50: 86,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    month: 'Aug',
    LTMData: {
      occupancy_rate25: 60,
      occupancy_rate50: 86,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 60,
      occupancy_rate50: 87,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Aug,23',
  },
  {
    '2021': {
      occupancy_rate25: 60,
      occupancy_rate50: 90,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 51,
      occupancy_rate50: 80,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2023': {
      occupancy_rate25: 56,
      occupancy_rate50: 80,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    month: 'Sep',
    LTMData: {
      occupancy_rate25: 56,
      occupancy_rate50: 80,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 51,
      occupancy_rate50: 80,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Sep,23',
  },
  {
    '2021': {
      occupancy_rate25: 60,
      occupancy_rate50: 85,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 49,
      occupancy_rate50: 74,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2023': {
      occupancy_rate25: 31,
      occupancy_rate50: 58,
      occupancy_rate75: 85,
      occupancy_rate90: 100,
    },
    month: 'Oct',
    LTMData: {
      occupancy_rate25: 31,
      occupancy_rate50: 58,
      occupancy_rate75: 85,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 49,
      occupancy_rate50: 74,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Oct,23',
  },
];

export const mainKpiRevenueDummyData = [
  {
    '2021': { revenue25: 787, revenue50: 2102, revenue75: 5247, revenue90: 10170 },
    '2022': { revenue25: 594, revenue50: 1676, revenue75: 4116, revenue90: 8106 },
    month: 'Nov',
    LTMData: { revenue25: 594, revenue50: 1676, revenue75: 4116, revenue90: 8106 },
    precedingData: { revenue25: 787, revenue50: 2102, revenue75: 5247, revenue90: 10170 },
    latestYear: 2022,
    previousYear: 2021,
    monthYear: 'Nov,22',
  },
  {
    '2021': { revenue25: 731, revenue50: 2105, revenue75: 5210, revenue90: 10203 },
    '2022': { revenue25: 921, revenue50: 2132, revenue75: 4753, revenue90: 8980 },
    month: 'Dec',
    LTMData: { revenue25: 921, revenue50: 2132, revenue75: 4753, revenue90: 8980 },
    precedingData: { revenue25: 731, revenue50: 2105, revenue75: 5210, revenue90: 10203 },
    latestYear: 2022,
    previousYear: 2021,
    monthYear: 'Dec,22',
  },
  {
    '2021': { revenue25: 0, revenue50: 1576, revenue75: 3626, revenue90: 4939 },
    '2022': { revenue25: 634, revenue50: 1850, revenue75: 4803, revenue90: 10050 },
    '2023': { revenue25: 404, revenue50: 1352, revenue75: 3683, revenue90: 7562 },
    month: 'Jan',
    LTMData: { revenue25: 404, revenue50: 1352, revenue75: 3683, revenue90: 7562 },
    precedingData: { revenue25: 634, revenue50: 1850, revenue75: 4803, revenue90: 10050 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Jan,23',
  },
  {
    '2021': { revenue25: 413, revenue50: 1498, revenue75: 3506, revenue90: 6621 },
    '2022': { revenue25: 874, revenue50: 2282, revenue75: 5239, revenue90: 10101 },
    '2023': { revenue25: 729, revenue50: 1836, revenue75: 3951, revenue90: 7745 },
    month: 'Feb',
    LTMData: { revenue25: 729, revenue50: 1836, revenue75: 3951, revenue90: 7745 },
    precedingData: { revenue25: 874, revenue50: 2282, revenue75: 5239, revenue90: 10101 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Feb,23',
  },
  {
    '2021': { revenue25: 401, revenue50: 1536, revenue75: 4135, revenue90: 7324 },
    '2022': { revenue25: 692, revenue50: 2062, revenue75: 5107, revenue90: 9907 },
    '2023': { revenue25: 651, revenue50: 1808, revenue75: 4070, revenue90: 8227 },
    month: 'Mar',
    LTMData: { revenue25: 651, revenue50: 1808, revenue75: 4070, revenue90: 8227 },
    precedingData: { revenue25: 692, revenue50: 2062, revenue75: 5107, revenue90: 9907 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Mar,23',
  },
  {
    '2021': { revenue25: 925, revenue50: 2576, revenue75: 5315, revenue90: 8448 },
    '2022': { revenue25: 1416, revenue50: 3147, revenue75: 6228, revenue90: 10314 },
    '2023': { revenue25: 1145, revenue50: 2657, revenue75: 5493, revenue90: 9084 },
    month: 'Apr',
    LTMData: { revenue25: 1145, revenue50: 2657, revenue75: 5493, revenue90: 9084 },
    precedingData: { revenue25: 1416, revenue50: 3147, revenue75: 6228, revenue90: 10314 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Apr,23',
  },
  {
    '2021': { revenue25: 644, revenue50: 2035, revenue75: 5112, revenue90: 10200 },
    '2022': { revenue25: 1174, revenue50: 2791, revenue75: 5992, revenue90: 10103 },
    '2023': { revenue25: 1012, revenue50: 2412, revenue75: 5398, revenue90: 9298 },
    month: 'May',
    LTMData: { revenue25: 1012, revenue50: 2412, revenue75: 5398, revenue90: 9298 },
    precedingData: { revenue25: 1174, revenue50: 2791, revenue75: 5992, revenue90: 10103 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'May,23',
  },
  {
    '2021': { revenue25: 1277, revenue50: 3167, revenue75: 6324, revenue90: 11122 },
    '2022': { revenue25: 1278, revenue50: 3138, revenue75: 6284, revenue90: 10601 },
    '2023': { revenue25: 1240, revenue50: 2820, revenue75: 5733, revenue90: 9347 },
    month: 'Jun',
    LTMData: { revenue25: 1240, revenue50: 2820, revenue75: 5733, revenue90: 9347 },
    precedingData: { revenue25: 1278, revenue50: 3138, revenue75: 6284, revenue90: 10601 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Jun,23',
  },
  {
    '2021': { revenue25: 2049, revenue50: 4203, revenue75: 7071, revenue90: 12488 },
    '2022': { revenue25: 2160, revenue50: 4098, revenue75: 6593, revenue90: 10788 },
    '2023': { revenue25: 1884, revenue50: 3801, revenue75: 6476, revenue90: 10220 },
    month: 'Jul',
    LTMData: { revenue25: 1884, revenue50: 3801, revenue75: 6476, revenue90: 10220 },
    precedingData: { revenue25: 2160, revenue50: 4098, revenue75: 6593, revenue90: 10788 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Jul,23',
  },
  {
    '2021': { revenue25: 2233, revenue50: 4488, revenue75: 7622, revenue90: 12769 },
    '2022': { revenue25: 1561, revenue50: 3593, revenue75: 6600, revenue90: 10464 },
    '2023': { revenue25: 1662, revenue50: 3585, revenue75: 6236, revenue90: 9701 },
    month: 'Aug',
    LTMData: { revenue25: 1662, revenue50: 3585, revenue75: 6236, revenue90: 9701 },
    precedingData: { revenue25: 1561, revenue50: 3593, revenue75: 6600, revenue90: 10464 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Aug,23',
  },
  {
    '2021': { revenue25: 1547, revenue50: 3693, revenue75: 6511, revenue90: 10968 },
    '2022': { revenue25: 1179, revenue50: 2816, revenue75: 5538, revenue90: 9502 },
    '2023': { revenue25: 1403, revenue50: 2910, revenue75: 5374, revenue90: 8297 },
    month: 'Sep',
    LTMData: { revenue25: 1403, revenue50: 2910, revenue75: 5374, revenue90: 8297 },
    precedingData: { revenue25: 1179, revenue50: 2816, revenue75: 5538, revenue90: 9502 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Sep,23',
  },
  {
    '2021': { revenue25: 1503, revenue50: 3272, revenue75: 6174, revenue90: 10746 },
    '2022': { revenue25: 1045, revenue50: 2398, revenue75: 5079, revenue90: 9057 },
    '2023': { revenue25: 717, revenue50: 1928, revenue75: 4301, revenue90: 7946 },
    month: 'Oct',
    LTMData: { revenue25: 717, revenue50: 1928, revenue75: 4301, revenue90: 7946 },
    precedingData: { revenue25: 1045, revenue50: 2398, revenue75: 5079, revenue90: 9057 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Oct,23',
  },
];

export const mainKpiListingDummydata = [
  {
    '2021': { active_listings_count: 1026 },
    '2022': { active_listings_count: 1269 },
    month: 'Nov',
    LTMData: { active_listings_count: 1269 },
    precedingData: { active_listings_count: 1026 },
    latestYear: 2022,
    previousYear: 2021,
    monthYear: 'Nov,22',
  },
  {
    '2021': { active_listings_count: 990 },
    '2022': { active_listings_count: 1275 },
    month: 'Dec',
    LTMData: { active_listings_count: 1275 },
    precedingData: { active_listings_count: 990 },
    latestYear: 2022,
    previousYear: 2021,
    monthYear: 'Dec,22',
  },
  {
    '2021': { active_listings_count: 271 },
    '2022': { active_listings_count: 1093 },
    '2023': { active_listings_count: 1368 },
    month: 'Jan',
    LTMData: { active_listings_count: 1368 },
    precedingData: { active_listings_count: 1093 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Jan,23',
  },
  {
    '2021': { active_listings_count: 433 },
    '2022': { active_listings_count: 1133 },
    '2023': { active_listings_count: 1611 },
    month: 'Feb',
    LTMData: { active_listings_count: 1611 },
    precedingData: { active_listings_count: 1133 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Feb,23',
  },
  {
    '2021': { active_listings_count: 443 },
    '2022': { active_listings_count: 1245 },
    '2023': { active_listings_count: 1826 },
    month: 'Mar',
    LTMData: { active_listings_count: 1826 },
    precedingData: { active_listings_count: 1245 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Mar,23',
  },
  {
    '2021': { active_listings_count: 690 },
    '2022': { active_listings_count: 1383 },
    '2023': { active_listings_count: 1940 },
    month: 'Apr',
    LTMData: { active_listings_count: 1940 },
    precedingData: { active_listings_count: 1383 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Apr,23',
  },
  {
    '2021': { active_listings_count: 798 },
    '2022': { active_listings_count: 1439 },
    '2023': { active_listings_count: 1966 },
    month: 'May',
    LTMData: { active_listings_count: 1966 },
    precedingData: { active_listings_count: 1439 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'May,23',
  },
  {
    '2021': { active_listings_count: 832 },
    '2022': { active_listings_count: 1463 },
    '2023': { active_listings_count: 2351 },
    month: 'Jun',
    LTMData: { active_listings_count: 2351 },
    precedingData: { active_listings_count: 1463 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Jun,23',
  },
  {
    '2021': { active_listings_count: 954 },
    '2022': { active_listings_count: 1520 },
    '2023': { active_listings_count: 2494 },
    month: 'Jul',
    LTMData: { active_listings_count: 2494 },
    precedingData: { active_listings_count: 1520 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Jul,23',
  },
  {
    '2021': { active_listings_count: 973 },
    '2022': { active_listings_count: 1545 },
    '2023': { active_listings_count: 3191 },
    month: 'Aug',
    LTMData: { active_listings_count: 3191 },
    precedingData: { active_listings_count: 1545 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Aug,23',
  },
  {
    '2021': { active_listings_count: 1114 },
    '2022': { active_listings_count: 1448 },
    '2023': { active_listings_count: 2720 },
    month: 'Sep',
    LTMData: { active_listings_count: 2720 },
    precedingData: { active_listings_count: 1448 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Sep,23',
  },
  {
    '2021': { active_listings_count: 1104 },
    '2022': { active_listings_count: 1351 },
    '2023': { active_listings_count: 2359 },
    month: 'Oct',
    LTMData: { active_listings_count: 2359 },
    precedingData: { active_listings_count: 1351 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Oct,23',
  },
];

// z indeces

export const APP_BAR_Z_INDEX = 1100;
export const SIDE_BAR_Z_INDEX = APP_BAR_Z_INDEX + 1;
export const KPI_NAV_BAR_Z_INDEX = APP_BAR_Z_INDEX - 1;
export const FILTER_FLOAT_BUTTON_Z_INDEX_DESKTOP = KPI_NAV_BAR_Z_INDEX - 1;
export const FILTER_FLOAT_BUTTON_Z_INDEX_MOBILE = APP_BAR_Z_INDEX + 1;
export const NEIGHBOURHOOD_TOOLTIP_Z_INDEX = 999997;

export const NAV_BAR_DYNAMIC_SVG_SIMPLE = 'TE6zqUJQPCPH1_-_nRgplwkp9A7SjUbq0Gcq2VDndKA=';

//local storage key
export const DATA_VERIFICATION_ATTEMPT_TRACKER_LS_KEY = 'data_verification_attempt_tracker';

export const MAP_VIEW_TOOLTIP_MAPPING = {
  'Occupancy (Median)': 0,
  Revenue: 1,
  'Nightly Rate (Median)': 2,
  'Active Listings': 3,
};

export const OVERVIEW_DASHBOARD_FILTER_DEMO_DATA = {
  propertyType: {
    entire_home: {
      occupancyRate: 60,
      adr: 45,
      revenue: 47507,
    },
    private_room: {
      occupancyRate: 70,
      adr: 95,
      revenue: 18189,
    },
    condo: {
      occupancyRate: 80,
      adr: 45,
      revenue: 41373,
    },
    hotel_room: {
      occupancyRate: 60,
      adr: 95,
      revenue: 23367,
    },
    shared_room: {
      occupancyRate: 70,
      adr: 45,
      revenue: 9343.5,
    },
  },
  propertySize: {
    studio: {
      occupancyRate: 80,
      adr: 100,
      revenue: 20000,
    },
    '1': {
      occupancyRate: 60,
      adr: 120,
      revenue: 30000,
    },
    '2': {
      occupancyRate: 70,
      adr: 140,
      revenue: 40000,
    },
    '3': {
      occupancyRate: 80,
      adr: 160,
      revenue: 50000,
    },
    '4': {
      occupancyRate: 60,
      adr: 180,
      revenue: 60000,
    },
    '5': {
      occupancyRate: 70,
      adr: 200,
      revenue: 70000,
    },
    '6+': {
      occupancyRate: 60,
      adr: 220,
      revenue: 80000,
    },
  },
  amenity: {
    pool: {
      revPanChange: 100,
    },
    parking: {
      revPanChange: 0,
    },
    hot_tub: {
      revPanChange: 0,
    },
    gym: {
      revPanChange: 0,
    },
    dryer: {
      revPanChange: 10,
    },
    washer: {
      revPanChange: 14,
    },
    kitchen: {
      revPanChange: 42,
    },
    ac: {
      revPanChange: 0,
    },
    heating: {
      revPanChange: 9,
    },
    wifi: {
      revPanChange: 23,
    },
    tv: {
      revPanChange: 11,
    },
    bbq_grill: {
      revPanChange: 0,
    },
    fireplace: {
      revPanChange: 11,
    },
    breakfast: {
      revPanChange: 0,
    },
  },
  bathroomNumber: {
    '0': {
      occupancyRate: 60,
    },
    '1': {
      occupancyRate: 70,
    },
    '2': {
      occupancyRate: 80,
    },
    '3': {
      occupancyRate: 60,
    },
    '4': {
      occupancyRate: 70,
    },
    '5': {
      occupancyRate: 80,
    },
    '6+': {
      occupancyRate: 60,
    },
  },
  adrRange: {
    '11-93': {
      occupancyRate: 60,
    },
    '93-134': {
      occupancyRate: 70,
    },
    '134-177': {
      occupancyRate: 80,
    },
    '177-251': {
      occupancyRate: 60,
    },
    '251-1934': {
      occupancyRate: 70,
    },
  },
  ratingRange: {
    '0-4': {
      occupancyRate: 60,
    },
    '4-4.3': {
      occupancyRate: 70,
    },
    '4.3-4.6': {
      occupancyRate: 80,
    },
    '4.6-4.8': {
      occupancyRate: 60,
    },
    '4.8-5.1': {
      occupancyRate: 70,
    },
  },
  minNightRange: {
    '1-6': {
      occupancyRate: 60,
    },
    '7-29': {
      occupancyRate: 70,
    },
    '30-999': {
      occupancyRate: 80,
    },
  },
  capacity: {
    '1': {
      supply: 60,
    },
    '2': {
      supply: 70,
    },
    '3': {
      supply: 80,
    },
    '4': {
      supply: 60,
    },
    '5': {
      supply: 70,
    },
    '6': {
      supply: 80,
    },
    '7': {
      supply: 60,
    },
    '8': {
      supply: 70,
    },
    '9': {
      supply: 80,
    },
    '10': {
      supply: 60,
    },
    '11': {
      supply: 70,
    },
    '12': {
      supply: 80,
    },
    '13': {
      supply: 60,
    },
    '14': {
      supply: 70,
    },
    '15': {
      supply: 80,
    },
    '16+': {
      supply: 60,
    },
  },
  daysAvailable: {
    '1-90': {
      supply: 60,
    },
    '91-180': {
      supply: 70,
    },
    '181-270': {
      supply: 80,
    },
    '271-366': {
      supply: 60,
    },
  },
  listingsPerHost: {
    '1': {
      occupancyRate: 60,
    },
    '2-5': {
      occupancyRate: 70,
    },
    '6-20': {
      occupancyRate: 80,
    },
    '21+': {
      occupancyRate: 60,
    },
  },
  propertyTypeMetricsDistributionObject: {
    entire_home: {
      occupancyRate: {
        '0 - 10': 2,
        '10 - 20': 44,
        '20 - 30': 77,
        '30 - 40': 155,
        '40 - 50': 182,
        '50 - 60': 269,
        '60 - 70': 279,
        '70 - 80': 300,
        '80 - 90': 274,
        '90 - 100': 364,
      },
      adr: {
        '49 - 116': 316,
        '116 - 276': 1095,
        '276 - 655': 426,
        '655 - 1553': 94,
        '1553 - 3685': 14,
      },
      revenue: {
        '2922 - 9959': 19,
        '9959 - 33941': 529,
        '33941 - 115679': 1193,
        '115679 - 394259': 189,
        '394259 - 1343713': 15,
      },
    },
    private_room: {
      occupancyRate: {
        '0 - 10': 2,
        '10 - 20': 26,
        '20 - 30': 43,
        '30 - 40': 61,
        '40 - 50': 94,
        '50 - 60': 94,
        '60 - 70': 133,
        '70 - 80': 132,
        '80 - 90': 105,
        '90 - 100': 111,
      },
      adr: {
        '21 - 66': 284,
        '66 - 207': 474,
        '207 - 650': 39,
        '650 - 2041': 3,
        '2041 - 6407': 1,
      },
      revenue: {
        '1198 - 4892': 19,
        '4892 - 19976': 467,
        '19976 - 81568': 300,
        '81568 - 333075': 14,
        '333075 - 1360076': 0,
      },
    },
    condo: {
      occupancyRate: {
        '0 - 10': 0,
        '10 - 20': 7,
        '20 - 30': 19,
        '30 - 40': 31,
        '40 - 50': 44,
        '50 - 60': 74,
        '60 - 70': 84,
        '70 - 80': 96,
        '80 - 90': 81,
        '90 - 100': 104,
      },
      adr: {
        '60 - 102': 52,
        '102 - 174': 265,
        '174 - 296': 182,
        '296 - 503': 35,
        '503 - 856': 5,
      },
      revenue: {
        '7334 - 14305': 10,
        '14305 - 27902': 93,
        '27902 - 54424': 299,
        '54424 - 106154': 124,
        '106154 - 207055': 14,
      },
    },
    hotel_room: {
      occupancyRate: {
        '0 - 10': 0,
        '10 - 20': 0,
        '20 - 30': 2,
        '30 - 40': 0,
        '40 - 50': 0,
        '50 - 60': 2,
        '60 - 70': 0,
        '70 - 80': 1,
        '80 - 90': 3,
        '90 - 100': 2,
      },
      adr: {
        '72 - 88': 5,
        '88 - 107': 0,
        '107 - 130': 1,
        '130 - 158': 3,
        '158 - 192': 0,
      },
      revenue: {
        '13724 - 18285': 2,
        '18285 - 24363': 1,
        '24363 - 32460': 4,
        '32460 - 43249': 1,
        '43249 - 57623': 1,
      },
    },
    shared_room: {
      occupancyRate: {
        '0 - 10': 0,
        '10 - 20': 1,
        '20 - 30': 1,
        '30 - 40': 1,
        '40 - 50': 1,
        '50 - 60': 2,
        '60 - 70': 2,
        '70 - 80': 1,
        '80 - 90': 0,
        '90 - 100': 0,
      },
      adr: {
        '28 - 39': 7,
        '39 - 55': 1,
        '55 - 77': 0,
        '77 - 108': 0,
        '108 - 152': 0,
      },
      revenue: {
        '1228 - 2086': 1,
        '2086 - 3544': 0,
        '3544 - 6021': 2,
        '6021 - 10229': 5,
        '10229 - 17377': 1,
      },
    },
  },
};

export const DEMO_DASHBOARD_FILTER_GRAPH_TOOLTIP_LTM_DATA = {
  occupancyRate: [
    { date: '2024-01', metric: 63 },
    { date: '2024-02', metric: 72 },
    { date: '2024-03', metric: 68 },
    { date: '2024-04', metric: 75 },
    { date: '2024-05', metric: 65 },
    { date: '2024-06', metric: 70 },
    { date: '2024-07', metric: 78 },
    { date: '2024-08', metric: 68 },
    { date: '2024-09', metric: 73 },
    { date: '2024-10', metric: 77 },
    { date: '2024-11', metric: 63 },
    { date: '2024-12', metric: 80 },
  ],
  adr: [
    { date: '2024-01', metric: 80 },
    { date: '2024-02', metric: 85 },
    { date: '2024-03', metric: 78 },
    { date: '2024-04', metric: 92 },
    { date: '2024-05', metric: 88 },
    { date: '2024-06', metric: 82 },
    { date: '2024-07', metric: 96 },
    { date: '2024-08', metric: 87 },
    { date: '2024-09', metric: 81 },
    { date: '2024-10', metric: 94 },
    { date: '2024-11', metric: 76 },
    { date: '2024-12', metric: 89 },
  ],
  revenue: [
    { date: '2024-01', metric: 5600 },
    { date: '2024-02', metric: 6250 },
    { date: '2024-03', metric: 7200 },
    { date: '2024-04', metric: 8900 },
    { date: '2024-05', metric: 7400 },
    { date: '2024-06', metric: 8100 },
    { date: '2024-07', metric: 9500 },
    { date: '2024-08', metric: 8300 },
    { date: '2024-09', metric: 7200 },
    { date: '2024-10', metric: 8800 },
    { date: '2024-11', metric: 6700 },
    { date: '2024-12', metric: 9500 },
  ],
};

export const US_CENTER = { lat: 39.8333333, lng: -98.585522 };
export const FIXED_CENTER_FOR_US_IN_MOBILE_VIEW = {
  lat: 14.372310047369794,
  lng: -98.58552199999998,
};

export const UK_CENTER = { lat: 54.1553497202996, lng: -2.89558470050636 };
export const FIXED_CENTER_FOR_UK_IN_MOBILE_VIEW = { lat: 54.1553497202996, lng: -2.89558470050636 };

export const AU_CENTER = { lat: -25.274398, lng: 133.775136 };
export const FIXED_CENTER_FOR_AU_IN_MOBILE_VIEW = { lat: -25.274398, lng: 133.775136 };

export const CA_CENTER = { lat: 56.130366, lng: -106.346771 };
export const FIXED_CENTER_FOR_CA_IN_MOBILE_VIEW = CA_CENTER;

export const MIN_ROI_FOR_MARKET_GRAD_IN_OVERVIEW = 2.0;
export const MAX_ROI_FOR_MARKET_GRAD_IN_OVERVIEW = 5.6;

export const userDisplayFriendlyCountryCode = {
  US: 'US',
  GB: 'UK',
  AU: 'Australia',
  CA: 'Canada',
};

export const AVAILABLE_COUNTRY = {
  US: 'United States',
  GB: 'United Kingdom',
  AU: 'Australia',
  CA: 'Canada',
};

export const ALL_COUNTRY = {
  US: 'United States',
  GB: 'United Kingdom',
  AU: 'Australia',
  CA: 'Canada',
  AF: 'Afghanistan',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia (Plurinational State of)',
  BQ: 'Bonaire, Sint Eustatius and Saba',
  BA: 'Bosnia and Herzegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  CV: 'Cabo Verde',
  KH: 'Cambodia',
  CM: 'Cameroon',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands',
  CO: 'Colombia',
  KM: 'Comoros',
  CD: 'Congo (the Democratic Republic of the)',
  CG: 'Congo',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  HR: 'Croatia',
  CU: 'Cuba',
  CW: 'Curaçao',
  CY: 'Cyprus',
  CZ: 'Czechia',
  CI: "Côte d'Ivoire",
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  SZ: 'Eswatini',
  ET: 'Ethiopia',
  FK: 'Falkland Islands [Malvinas]',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  TF: 'French Southern Territories',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard Island and McDonald Islands',
  VA: 'Holy See',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran (Islamic Republic of)',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KP: "Korea (the Democratic People's Republic of)",
  KR: 'Korea (the Republic of)',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: "Lao People's Democratic Republic",
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia (Federated States of)',
  MD: 'Moldova (the Republic of)',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestine',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  MK: 'Republic of North Macedonia',
  RO: 'Romania',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  RE: 'Réunion',
  BL: 'Saint Barthélemy',
  SH: 'Saint Helena, Ascension and Tristan da Cunha',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin (French part)',
  PM: 'Saint Pierre and Miquelon',
  VC: 'Saint Vincent and the Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome and Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SX: 'Sint Maarten (Dutch part)',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia and the South Sandwich Islands',
  SS: 'South Sudan',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard and Jan Mayen',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syrian Arab Republic',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TZ: 'Tanzania, United Republic of',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks and Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  UM: 'United States Minor Outlying Islands',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela (Bolivarian Republic of)',
  VN: 'Viet Nam',
  VG: 'Virgin Islands (British)',
  VI: 'Virgin Islands (U.S.)',
  WF: 'Wallis and Futuna',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  AX: 'Åland Islands',
};

export const DISCOVERY_API_CACHE_DURATION = 1 * 60 * 60 * 1000;

export const BOOKING_STATUS_COLOR = {
  inactive: '#EFEFEF',
  available: '#71FF64',
  recentlyBooked: '#F95738',
  booked: '#86F8FF',
};

export const dummyData = [
  {
    name: 'Page A',
    uv: 4000,
    pv: 2400,
    amt: 2100,
  },
  {
    name: 'Page B',
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: 'Page C',
    uv: 2000,
    pv: 9800,
    amt: 2190,
  },
  {
    name: 'Page D',
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: 'Page E',
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: 'Page F',
    uv: 2390,
    pv: 3800,
    amt: 2200,
  },
  {
    name: 'Page G',
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];
export const PRO_CTA = 'Upgrade to Pro Plan';
export const EXPERT_CTA = 'Upgrade to Expert Plan';
export const EXPERT_CTA_FOR_TAILOR_REGION = 'Upgrade to Expert Plan For Custom Market';
export const UNLOCK_CTA = 'Unlock';
export const SCALE_CTA = 'Upgrade to Scale Plan';
export const SUBSCRIPTION_MODAL_DATA_GRID_WIDTH_FOR_MOBILE = '900px';
export const SUBSCRIPTION_MODAL_DATA_GRID_WIDTH = '1230px';

export const SUBSCRIPTION_TABLE_ROWS = [
  {
    id: 0,
    feature: 'Null',
    starter: 'Insight Starter',
    pro: 'Insight Pro',
    expert: 'Analytics Expert',
    scale: 'Market Intelligence Scale',
  },
  {
    id: 1,
    feature: 'Historical Data',
    starter: 'year1',
    pro: 'year2',
    expert: 'year3',
    scale: 'through2021',
    featureTooltip: 'historical_data',
  },
  {
    id: 2,
    feature: 'Market Overview',
    starter: 'yes',
    pro: 'yes',
    expert: 'yes',
    scale: 'yes',
    featureTooltip: 'market_overview',
  },
  {
    id: 3,
    feature: 'Market Details',
    starter: 'no',
    pro: 'yes',
    expert: 'yes',
    scale: 'yes',
    featureTooltip: 'market_details',
  },
  {
    id: 4,
    feature: 'Market Explorer',
    starter: 'no',
    expert: '5 Searches',
    scale: '20 Searches',
    featureTooltip: 'market_explorer',
  },
  {
    id: 5,
    feature: 'Market Pacing Insights',
    starter: 'no',
    pro: 'comingSoon',
    expert: 'comingSoon',
    scale: 'comingSoon',
    featureTooltip: 'market_pacing_insights',
  },
  {
    id: 6,
    feature: 'Guest Insights⭐',
    starter: 'no',
    pro: 'yes',
    expert: 'yes',
    scale: 'yes',
    featureTooltip: 'guest_demographics',
  },
  {
    id: 7,
    feature: 'Host Insights',
    starter: 'no',
    pro: 'no',
    expert: 'Unlimited',
    scale: 'Unlimited',
    featureTooltip: 'host_performance_overview',
  },
  {
    id: 8,
    feature: 'Interactive Map Insights ⭐',
    starter: 'no',
    pro: 'no',
    expert: 'yes',
    scale: 'yes',
    featureTooltip: 'interactive_map_insights',
  },
  {
    id: 9,
    feature: 'Calculator (Estimator)',
    starter: 'Limited',
    pro: 'Unlimited (Without Comps Historical data)',
    expert: 'Unlimited',
    scale: 'Unlimited',
    featureTooltip: 'calculator_estimator',
  },
  {
    id: 10,
    feature: 'Listing Overview',
    starter: 'no',
    pro: 'yes',
    expert: 'yes',
    scale: 'yes',
    featureTooltip: 'listing_overview',
  },
  {
    id: 11,
    feature: 'Listing Performance Breakdown',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    scale: 'yes',
    featureTooltip: 'listing_performance_breakdown',
  },
  {
    id: 12,
    feature: 'Listing Filters',
    starter: 'no',
    pro: 'yes',
    expert: 'yes',
    scale: 'yes',
    featureTooltip: 'listing_filters',
  },
  {
    id: 13,
    feature: 'Amenities & Performance Filters ⭐',
    starter: 'no',
    pro: 'no',
    expert: 'yes',
    scale: 'yes',
    featureTooltip: 'amenities_performance_filters',
  },
  {
    id: 14,
    feature: 'Markets Included',
    starter: 'allMarkets',
    pro: 'allMarkets',
    expert: 'allMarkets',
    scale: 'allMarkets',
    featureTooltip: 'markets_included',
  },
  {
    id: 15,
    feature: 'Draw Custom Markets ⭐',
    starter: 'no',
    pro: 'no',
    expert: 'yes',
    scale: 'yes',
    featureTooltip: 'draw_custom_markets',
  },
  {
    id: 16,
    feature: 'Market Compare',
    starter: 'no',
    pro: 'no',
    expert: 'Unlimited',
    scale: 'Unlimited',
    featureTooltip: 'market_compare',
  },
  {
    id: 17,
    feature: 'Report Compare',
    starter: 'no',
    pro: 'no',
    expert: 'Unlimited',
    scale: 'Unlimited',
    featureTooltip: 'report_compare',
  },
  {
    id: 18,
    feature: 'CSV Data Downloads (Market KPIs)',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    scale: '20 Markets',
    featureTooltip: 'csv_data_downloads',
  },
  {
    id: 19,
    feature: 'CSV Data Downloads (Market Compare)',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    scale: '20 Markets',
    featureTooltip: 'csv_data_downloads_market_compare',
  },
  {
    id: 20,
    feature: 'CSV Data Downloads (Report Compare)',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    scale: '20 Markets',
    featureTooltip: 'csv_data_downloads_report_compare',
  },
  {
    id: 21,
    feature: 'CSV Data Downloads (Individual Listing)',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    scale: 'Not Included',
    featureTooltip: 'csv_data_downloads_individual_listing',
  },
  {
    id: 22,
    feature: 'Market Table View (Discovery)',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    scale: '20 Markets',
    featureTooltip: 'market_table_view_discovery',
  },
  {
    id: 23,
    feature: 'Market Insights Export',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    scale: '20 Markets',
    featureTooltip: 'market_insights_export',
  },
  {
    id: 24,
    feature: 'Top Airbnb Management',
    starter: 'Limited to top 5 hosts',
    pro: 'Limited to top 5 hosts',
    expert: 'See data on all professional hosts (1 market/mo)',
    scale: 'See data on all professional hosts (20 markets/mo)',
    featureTooltip: 'property_manager_view',
  },
];

export const SUBSCRIPTION_TABLE_ROWS_FOR_MOBILE_VIEW = [
  {
    id: 0,
    feature: 'Null',
    starter: 'Insight Starter',
    pro: 'Insight Pro',
    expert: 'Analytics Expert',
    scale: 'Market Intelligence Scale',
  },
  {
    id: 1,
    feature: '',
    starter: 'Historical Data',
    pro: '',
    expert: '',
    scale: '',
  },
  {
    id: 2,
    feature: 'Historical Data',
    starter: 'year1',
    pro: 'year2',
    expert: 'year3',
    scale: 'through2021',
  },
  {
    id: 3,
    starter: 'Market Overview',
    feature: '',
    pro: '',
    expert: '',
    scale: '',
  },
  {
    id: 4,
    feature: 'Market Overview',
    starter: 'yes',
    pro: 'yes',
    expert: 'yes',
    scale: 'yes',
  },
  {
    id: 5,
    starter: 'Market Details',
    feature: '',
    pro: '',
    expert: '',
    scale: '',
  },
  {
    id: 6,
    feature: 'Market Details',
    starter: 'no',
    pro: 'yes',
    expert: 'yes',
    scale: 'yes',
  },
  {
    id: 7,
    starter: 'Market Pacing Insights',
    feature: '',
    pro: '',
    expert: '',
    scale: '',
  },
  {
    id: 8,
    feature: 'Market Pacing Insights',
    starter: 'no',
    pro: 'comingSoon',
    expert: 'comingSoon',
    scale: 'comingSoon',
  },
  {
    id: 9,
    starter: 'Guest Insights⭐',
    feature: '',
    pro: '',
    expert: '',
    scale: '',
  },
  {
    id: 10,
    feature: 'Guest Insights⭐',
    starter: 'no',
    pro: 'yes',
    expert: 'yes',
    scale: 'yes',
  },
  {
    id: 11,
    starter: 'Host Performance Overview',
    feature: '',
    pro: '',
    expert: '',
    scale: '',
  },
  {
    id: 12,
    feature: 'Host Performance Overview',
    starter: 'no',
    pro: 'top10',
    expert: 'top10',
    scale: 'allHosts',
  },
  {
    id: 13,
    starter: 'Interactive Map Insights ⭐',
    feature: '',
    pro: '',
    expert: '',
    scale: '',
  },
  {
    id: 14,
    feature: 'Interactive Map Insights ⭐',
    starter: 'no',
    pro: 'no',
    expert: 'yes',
    scale: 'yes',
  },
  {
    id: 15,
    starter: 'Calculator (Estimator)',
    feature: '',
    pro: '',
    expert: '',
    scale: '',
  },
  {
    id: 16,
    feature: 'Calculator (Estimator)',
    starter: 'Limited',
    pro: 'Unlimited (Without Comps Historical data)',
    expert: 'Unlimited',
    scale: 'Unlimited',
  },
  {
    id: 17,
    starter: 'Listing Overview',
    feature: '',
    pro: '',
    expert: '',
    scale: '',
  },
  {
    id: 18,
    feature: 'Listing Overview',
    starter: 'no',
    pro: 'yes',
    expert: 'yes',
    scale: 'yes',
  },
  {
    id: 19,
    starter: 'Listing Performance Breakdown',
    feature: '',
    pro: '',
    expert: '',
    scale: '',
  },
  {
    id: 20,
    feature: 'Listing Performance Breakdown',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    scale: 'yes',
  },
  {
    id: 21,
    starter: 'Listing Filters',
    feature: '',
    pro: '',
    expert: '',
    scale: '',
  },
  {
    id: 22,
    feature: 'Listing Filters',
    starter: 'no',
    pro: 'yes',
    expert: 'yes',
    scale: 'yes',
  },
  {
    id: 23,
    starter: 'Amenities & Performance Filters ⭐',
    feature: '',
    pro: '',
    expert: '',
    scale: '',
  },
  {
    id: 24,
    feature: 'Amenities & Performance Filters ⭐',
    starter: 'no',
    pro: 'no',
    expert: 'yes',
    scale: 'yes',
  },
  {
    id: 25,
    starter: 'Markets included',
    feature: '',
    pro: '',
    expert: '',
    scale: '',
  },
  {
    id: 26,
    feature: 'Markets included',
    starter: 'allMarkets',
    pro: 'allMarkets',
    expert: 'allMarkets',
    scale: 'allMarkets',
  },
  {
    id: 27,
    starter: 'Draw Custom Markets ⭐',
    feature: '',
    pro: '',
    expert: '',
    scale: '',
  },
  {
    id: 28,
    feature: 'Draw Custom Markets ⭐',
    starter: 'no',
    pro: 'no',
    expert: 'yes',
    scale: 'yes',
  },
  {
    id: 31,
    starter: 'Market Table View (Discovery)',
    feature: '',
    pro: '',
    expert: '',
    scale: '',
  },
  {
    id: 32,
    feature: 'Market Table View (Discovery)',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    scale: '20 Markets',
  },
  {
    id: 33,
    starter: 'Market Insights Export',
    feature: '',
    pro: '',
    expert: '',
    scale: '',
  },
  {
    id: 34,
    feature: 'Market Insights Export',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    scale: '20 Markets',
  },
  {
    id: 35,
    starter: 'Property Manager View',
    feature: '',
    pro: '',
    expert: '',
    scale: '',
  },
  {
    id: 36,
    feature: 'Property Manager View',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    scale: '20 Markets',
  },
  // {
  //   id: 39,
  //   starter: 'Money Back Gurantee',
  //   feature: '',
  //   pro: '',
  //   expert: '',
  //   scale: '',
  // },
  // {
  //   id: 40,
  //   feature: 'Money Back Gurantee',
  //   starter: 'yes',
  //   pro: 'yes',
  //   expert: 'yes',
  //   scale: 'yes',
  // },
];

const SPAIN_DUMMY_MARKET = {
  overview: {
    district: 'centro',
    city: 'madrid',
    country: 'spain',
    id: 875,
  },
  estimator: {
    address: 'Plaza de España, Plaza de España, Madrid, Spain',
    coordinates: { lat: 40.4167754, lng: -3.7037902 },
  },
};

const DUBAI_DUMMY_MARKET = {
  overview: {
    district: 'dubai production city',
    city: '0',
    country: 'united-arab-emirates',
    id: 105565,
  },
  estimator: {
    address: 'Dubai Internet City - Dubai - United Arab Emirates',
    coordinates: { lat: 25.0976119, lng: 55.163109 },
  },
};

const NOTH_ASIA_DUMMY_MARKET = {
  overview: {
    district: 'vadhana',
    city: '0',
    country: 'thailand',
    id: 319124,
  },
  estimator: {
    address: 'Kuta Beach Skate Park, Kuta, Badung Regency, Bali, Indonesia',
    coordinates: { lat: -8.7133327, lng: 115.1675843 },
  },
};

const MEXICO_DUMMY_MARKET = {
  overview: {
    district: 'colonia condesa, mexico city',
    city: '0',
    country: 'mexico',
    id: 113198,
  },
  estimator: {
    address: 'Joaquina Beach, State of Santa Catarina, Brazil',
    coordinates: { lat: -27.6293577, lng: -48.4490173 },
  },
};

const US_CANADA_DUMMY_MARKET = {
  overview: {
    district: 'Boca Raton',
    city: 'FL',
    country: 'United-States',
    id: 1574,
  },
  estimator: {
    address: 'Ocean Drive, Miami Beach, FL, USA',
    coordinates: { lat: 25.7685168, lng: -80.1332062 },
  },
};

const AU_NZ_DUMMY_MARKET = {
  overview: {
    district: 'sydney inner city',
    city: 'new south wales',
    country: 'australia',
    id: 190032,
  },
  estimator: {
    address: 'Surfers Paradise Beach, Queensland, Australia',
    coordinates: { lat: -27.9992435, lng: 153.4314575 },
  },
};

export const DUMMY_MARKET_AS_PER_SIGNUP_COUNTRY_CODE = {
  GB: {
    overview: {
      district: 'brighton and hove',
      city: 'east sussex',
      country: 'united-kingdom',
      id: 144140,
    },
    estimator: {
      address: 'Liverpool City Centre, Liverpool, UK',
      coordinates: { lat: 53.4047542, lng: -2.9811581 },
    },
  },
  FR: {
    overview: {
      district: 'antibes france',
      city: '0',
      country: 'france',
      id: 106713,
    },
    estimator: {
      address: 'Eiffel Tower, Avenue Gustave Eiffel, Paris, France',
      coordinates: { lat: 48.85837009999999, lng: 2.2944813 },
    },
  },
  IT: {
    overview: {
      district: 'bellagio, province of como, italy',
      city: '0',
      country: '0',
      id: 122383,
    },
    estimator: {
      address: '39, PEPARINI ACADEMY, Via Assisi, Rome, Metropolitan City of Rome Capital, Italy',
      coordinates: { lat: 41.8792184, lng: 12.5251955 },
    },
  },
  AU: AU_NZ_DUMMY_MARKET,
  NZ: AU_NZ_DUMMY_MARKET,
  US: US_CANADA_DUMMY_MARKET,
  CA: US_CANADA_DUMMY_MARKET,
  ES: SPAIN_DUMMY_MARKET,
  AL: SPAIN_DUMMY_MARKET,
  AD: SPAIN_DUMMY_MARKET,
  AT: SPAIN_DUMMY_MARKET,
  BY: SPAIN_DUMMY_MARKET,
  BE: SPAIN_DUMMY_MARKET,
  BA: SPAIN_DUMMY_MARKET,
  BG: SPAIN_DUMMY_MARKET,
  HR: SPAIN_DUMMY_MARKET,
  CY: SPAIN_DUMMY_MARKET,
  CZ: SPAIN_DUMMY_MARKET,
  DK: SPAIN_DUMMY_MARKET,
  EE: SPAIN_DUMMY_MARKET,
  FI: SPAIN_DUMMY_MARKET,
  DE: SPAIN_DUMMY_MARKET,
  GR: SPAIN_DUMMY_MARKET,
  HU: SPAIN_DUMMY_MARKET,
  IS: SPAIN_DUMMY_MARKET,
  IE: SPAIN_DUMMY_MARKET,
  LI: SPAIN_DUMMY_MARKET,
  LV: SPAIN_DUMMY_MARKET,
  LT: SPAIN_DUMMY_MARKET,
  LU: SPAIN_DUMMY_MARKET,
  MK: SPAIN_DUMMY_MARKET,
  MT: SPAIN_DUMMY_MARKET,
  MD: SPAIN_DUMMY_MARKET,
  MC: SPAIN_DUMMY_MARKET,
  ME: SPAIN_DUMMY_MARKET,
  NL: SPAIN_DUMMY_MARKET,
  NO: SPAIN_DUMMY_MARKET,
  PL: SPAIN_DUMMY_MARKET,
  PT: SPAIN_DUMMY_MARKET,
  RO: SPAIN_DUMMY_MARKET,
  RU: SPAIN_DUMMY_MARKET,
  SM: SPAIN_DUMMY_MARKET,
  RS: SPAIN_DUMMY_MARKET,
  SK: SPAIN_DUMMY_MARKET,
  SI: SPAIN_DUMMY_MARKET,
  SE: SPAIN_DUMMY_MARKET,
  CH: SPAIN_DUMMY_MARKET,
  UA: SPAIN_DUMMY_MARKET,
  VA: SPAIN_DUMMY_MARKET,
  DZ: SPAIN_DUMMY_MARKET,
  AO: SPAIN_DUMMY_MARKET,
  BJ: SPAIN_DUMMY_MARKET,
  BW: SPAIN_DUMMY_MARKET,
  BF: SPAIN_DUMMY_MARKET,
  BI: SPAIN_DUMMY_MARKET,
  CV: SPAIN_DUMMY_MARKET,
  CM: SPAIN_DUMMY_MARKET,
  CF: SPAIN_DUMMY_MARKET,
  TD: SPAIN_DUMMY_MARKET,
  KM: SPAIN_DUMMY_MARKET,
  CD: SPAIN_DUMMY_MARKET,
  DJ: SPAIN_DUMMY_MARKET,
  EG: SPAIN_DUMMY_MARKET,
  GQ: SPAIN_DUMMY_MARKET,
  ER: SPAIN_DUMMY_MARKET,
  SZ: SPAIN_DUMMY_MARKET,
  ET: SPAIN_DUMMY_MARKET,
  GA: SPAIN_DUMMY_MARKET,
  GM: SPAIN_DUMMY_MARKET,
  GH: SPAIN_DUMMY_MARKET,
  GN: SPAIN_DUMMY_MARKET,
  GW: SPAIN_DUMMY_MARKET,
  CI: SPAIN_DUMMY_MARKET,
  KE: SPAIN_DUMMY_MARKET,
  LS: SPAIN_DUMMY_MARKET,
  LR: SPAIN_DUMMY_MARKET,
  LY: SPAIN_DUMMY_MARKET,
  MG: SPAIN_DUMMY_MARKET,
  MW: SPAIN_DUMMY_MARKET,
  ML: SPAIN_DUMMY_MARKET,
  MR: SPAIN_DUMMY_MARKET,
  MU: SPAIN_DUMMY_MARKET,
  MA: SPAIN_DUMMY_MARKET,
  MZ: SPAIN_DUMMY_MARKET,
  NA: SPAIN_DUMMY_MARKET,
  NE: SPAIN_DUMMY_MARKET,
  NG: SPAIN_DUMMY_MARKET,
  CG: SPAIN_DUMMY_MARKET,
  RW: SPAIN_DUMMY_MARKET,
  ST: SPAIN_DUMMY_MARKET,
  SN: SPAIN_DUMMY_MARKET,
  SC: SPAIN_DUMMY_MARKET,
  SL: SPAIN_DUMMY_MARKET,
  SO: SPAIN_DUMMY_MARKET,
  ZA: SPAIN_DUMMY_MARKET,
  SS: SPAIN_DUMMY_MARKET,
  SD: SPAIN_DUMMY_MARKET,
  TZ: SPAIN_DUMMY_MARKET,
  TG: SPAIN_DUMMY_MARKET,
  TN: SPAIN_DUMMY_MARKET,
  UG: SPAIN_DUMMY_MARKET,
  ZM: SPAIN_DUMMY_MARKET,
  ZW: SPAIN_DUMMY_MARKET,
  BH: DUBAI_DUMMY_MARKET,
  IQ: DUBAI_DUMMY_MARKET,
  IR: DUBAI_DUMMY_MARKET,
  IL: DUBAI_DUMMY_MARKET,
  JO: DUBAI_DUMMY_MARKET,
  KW: DUBAI_DUMMY_MARKET,
  LB: DUBAI_DUMMY_MARKET,
  OM: DUBAI_DUMMY_MARKET,
  PS: DUBAI_DUMMY_MARKET,
  QA: DUBAI_DUMMY_MARKET,
  SA: DUBAI_DUMMY_MARKET,
  SY: DUBAI_DUMMY_MARKET,
  TR: DUBAI_DUMMY_MARKET,
  AE: DUBAI_DUMMY_MARKET,
  YE: DUBAI_DUMMY_MARKET,
  AF: DUBAI_DUMMY_MARKET,
  BD: DUBAI_DUMMY_MARKET,
  BT: DUBAI_DUMMY_MARKET,
  IN: DUBAI_DUMMY_MARKET,
  MV: DUBAI_DUMMY_MARKET,
  NP: DUBAI_DUMMY_MARKET,
  PK: DUBAI_DUMMY_MARKET,
  LK: DUBAI_DUMMY_MARKET,
  CN: NOTH_ASIA_DUMMY_MARKET,
  JP: NOTH_ASIA_DUMMY_MARKET,
  KR: NOTH_ASIA_DUMMY_MARKET,
  KP: NOTH_ASIA_DUMMY_MARKET,
  MN: NOTH_ASIA_DUMMY_MARKET,
  TW: NOTH_ASIA_DUMMY_MARKET,
  BN: NOTH_ASIA_DUMMY_MARKET,
  KH: NOTH_ASIA_DUMMY_MARKET,
  ID: NOTH_ASIA_DUMMY_MARKET,
  LA: NOTH_ASIA_DUMMY_MARKET,
  MY: NOTH_ASIA_DUMMY_MARKET,
  MM: NOTH_ASIA_DUMMY_MARKET,
  PH: NOTH_ASIA_DUMMY_MARKET,
  SG: NOTH_ASIA_DUMMY_MARKET,
  TH: NOTH_ASIA_DUMMY_MARKET,
  VN: NOTH_ASIA_DUMMY_MARKET,
  KZ: NOTH_ASIA_DUMMY_MARKET,
  KG: NOTH_ASIA_DUMMY_MARKET,
  TJ: NOTH_ASIA_DUMMY_MARKET,
  TM: NOTH_ASIA_DUMMY_MARKET,
  UZ: NOTH_ASIA_DUMMY_MARKET,
  AM: NOTH_ASIA_DUMMY_MARKET,
  AZ: NOTH_ASIA_DUMMY_MARKET,
  GE: NOTH_ASIA_DUMMY_MARKET,
  AR: MEXICO_DUMMY_MARKET,
  BO: MEXICO_DUMMY_MARKET,
  BR: MEXICO_DUMMY_MARKET,
  CL: MEXICO_DUMMY_MARKET,
  CO: MEXICO_DUMMY_MARKET,
  CR: MEXICO_DUMMY_MARKET,
  CU: MEXICO_DUMMY_MARKET,
  DO: MEXICO_DUMMY_MARKET,
  EC: MEXICO_DUMMY_MARKET,
  SV: MEXICO_DUMMY_MARKET,
  GT: MEXICO_DUMMY_MARKET,
  HT: MEXICO_DUMMY_MARKET,
  HN: MEXICO_DUMMY_MARKET,
  MX: MEXICO_DUMMY_MARKET,
  NI: MEXICO_DUMMY_MARKET,
  PA: MEXICO_DUMMY_MARKET,
  PY: MEXICO_DUMMY_MARKET,
  PE: MEXICO_DUMMY_MARKET,
  UY: MEXICO_DUMMY_MARKET,
  VE: MEXICO_DUMMY_MARKET,
};

export const BY_DEFAULT_HIDDEN_COLUMNS_IN_ADVANCED_DASHBOARD_COMPS_TAB = {
  id: false,
  hostListingCount: false,
  communicationRating: false,
  license: false,
  roomType: false,
  beds: false,
  expectations: false,
  hostLang: false,
  summary: false,
  localizedMinimunNightsDescription: false,
  isBussinessTravelReady: false,
  cohostIDs: false,
  roomTypeLocalized: false,
  cityGuidebook: false,
  hostGuidebook: false,
  neighbourhoodID: false,
  descriptionLanguage: false,
  guestSatisfactionOverall: false,
  homeTier: false,
  homeCollection: false,
  hostQuotes: false,
  requiredLicence: false,
  supportCleanerLivingWage: false,
  hostInteraction: false,
  otherPropertyTypes: false,
  isHotel: false,
  accessibilityModule: false,
  hasEssentialAmenities: false,
  visibility: false,
  securityDeposite: false,
  prices: false,
  availability_60: false,
  availability_90: false,
  availability_365: false,
  monthlyDiscountRaw: false,
  lastReview: false,
  firstReview: false,
  reviewPerMonth: false,
  calendarAvail: false,
  address: false,
  addressType: false,
  zipcode: false,
  usMetropolitan: false,
  neighbourhood: false,
  hostCountLastUpdated: false,
  reviewCacheLastUpdatedLTM: false,
  LTMPerformanceLastUpdated: false,
  avgBookingLeadLTM: false,
  avgBookedDailyRateLTM: false,
  noOfBookingLTM: false,
  hostName: false,
};

export const SAMPLE_DATA_URL =
  'https://docs.google.com/spreadsheets/d/1rdoDmy7NzBLn7xiuzxg9DLB9ze5-OmNua8QJsZ4Yz6g/edit?pli=1&gid=0#gid=0';
export const CALENDARY_URL_FOR_AMERICAN = 'https://calendly.com/d/cpcm-4fn-q6j/discovery-call';
export const CALENDARY_URL_FOR_NON_AMERICAN =
  'https://calendly.com/d/ckh6-qcc-xbv/discovery-call-apac-emea';

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const rating_marks = [
  {
    value: 3.9,
    label: '<4.0',
  },
  {
    value: 5.0,
    label: '5.0',
  },
];

export const special_country_code_currency_map = {
  AU: 'AUD',
  AT: 'EUR',
  BD: 'BDT',
  BE: 'EUR',
  BR: 'BRL',
  CA: 'CAD',
  CZ: 'EUR',
  DK: 'EUR',
  EG: 'EGP',
  FI: 'EUR',
  FR: 'EUR',
  DE: 'EUR',
  GR: 'EUR',
  HK: 'HKD',
  HU: 'EUR',
  IN: 'INR',
  ID: 'IDR',
  IR: 'IRR',
  IE: 'EUR',
  IL: 'ILS',
  IT: 'EUR',
  JP: 'JPY',
  MY: 'MYR',
  MX: 'MXN',
  NL: 'EUR',
  NZ: 'NZD',
  NO: 'EUR',
  PH: 'PHP',
  PL: 'EUR',
  PT: 'EUR',
  RO: 'EUR',
  SG: 'SGD',
  ZA: 'ZAR',
  KR: 'KRW',
  ES: 'EUR',
  SE: 'EUR',
  CH: 'CHF',
  TW: 'TWD',
  TH: 'THB',
  AE: 'AED',
  GB: 'GBP',
  US: 'USD',
};

export const PERCENTILES = ['25', '50', '75', '90'];

export const FEATURE_LIST = {
  pro: {
    default: [
      'Access 20+ graphs in the overview dashboard',
      'Heatmap Analysis',
      'Revenue Analysis',
      'Unlimited Airbnb Revenue Reports',
      // '15-day Money-Back Guarantee',
    ],
    kpiGraph: ['Market Overview (2 years historical data)', 'Market Details'],
    heatmap: ['Heatmap Analysis'],
    revenueByAmenities: ['Revenue Analysis'],
    hostsTable: ['Top 5 host statistics'],
    individualListingsKPI: ['Occupancy Rate, Nightly Rate, and Revenue of listings'],
    guestOriginGraphs: ['Guest Insights'],
  },
  expert: {
    default: [
      // added from pro
      'Market Overview — Worldwide Access',
      'Airbnb Calculator — Generate Unlimited Reports',
      'Access 20+ graphs in the overview dashboard',
      'Heatmap Analysis',
      'Revenue Analysis',
      // added from pro
      '3 years Historical Data',
      'Interactive Map Insightsg ⭐',
      'Amenities and Performance Filters ⭐',
      'Draw Custom Markets ⭐',
      // '15-day Money-Back Guarantee',
    ],
    // added from pro
    kpiGraph: ['Market Overview', 'Market Details'],
    heatmap: ['Heatmap Analysis'],
    revenueByAmenities: ['Revenue Analysis'],
    hostsTable: ['Top 5 host statistics'],
    individualListingsKPI: ['Occupancy Rate, Nightly Rate, and Revenue of listings'],
    guestOriginGraphs: ['Guest Insights'],
  },
  scale: {
    default: [
      'Historical Data through 2021',
      'Listing Performance Breakdown',
      'Complete Host Inisghts (20 Markets)',
      'Market Overview Table (20 Markets) Download',
      'Market Details Table (20 Markets) Download',
      'Property Manager Yable (20 Markets) Download',
      // '15-day Money-Back  guarantee',
    ],
  },
  estimatorPro: {
    default: [
      'Airbnb Calculator — Generate Unlimited Reports',
      'Market Overview - Worldwide Access',
      'Add or Remove Comps ⭐',
      'Download Report PDF',
      'Advanced Report Filters',
      'Future Projection Graphs',
      // '15-day Money-Back  Guarantee',
    ],
    trial: [
      'Supports any addresses worldwide for precise analysis',
      'Provides access to market data dashboards',
      'Includes historical comps data for deeper insights',
    ],
  },
};

export const OverViewMapSectionMarketStatsTooltip =
  'This section shows the median revenue of listings within the map area. The displayed values represent the median of all listings on the map. If you apply filters to the map, these values will adjust accordingly.';

export const TESTIMONIALS = [
  {
    rating: 5,
    comment:
      'Grateful for the affordable, easy to use, data from Airbtics. Will definitely use them again when looking for our next Airbnb. We were able to find our 1st Airbnb in 2 months.',
    reviewer: 'Augustin Lauren',
    reviewerRole: 'Founder @ JL Construction LLC',
    avatar: 'https://airbtics.com/wp-content/uploads/2023/09/avataaars-2.webp',
  },
  {
    rating: 5,
    comment:
      'The feature set is incredibly powerful, with the most in-depth data analysis for vacation rentals. All of the data is displayed in a very easy to understand breakdown. The simplicity of the user interface should not undermine how advanced the software is, the analytics and data-sets are the most accurate in the industry.',
    reviewer: 'Sterling Jones',
    reviewerRole: 'Founder @ Cohostin.com',
    avatar: 'https://airbtics.com/wp-content/uploads/2023/09/avataaars-4-1.webp',
  },
  {
    rating: 5,
    comment:
      'Thanks so much for putting together such great software! You are head and shoulders above AirDNA. You gave me EXACTLY what I needed to make very informed decisions on my latest rental property in Port St Joe, FL. Cheers!',
    reviewer: 'Michael Littleton',
    reviewerRole: 'Investor @ St Joe, FL',
    avatar: 'https://airbtics.com/wp-content/uploads/2023/09/avataaars-3-1.webp',
  },
  {
    rating: 5,
    comment:
      'Great customer service. Professional team. Data is updated everyday. Occupancy rate and daily rate data are updated dynamically allowing me to explore 25 neighbourhoods and communities in Orlando with one subscription.',
    reviewer: 'Vincent Madden',
    reviewerRole: 'Superhost @ Malibu, CA',
    avatar: 'https://airbtics.com/wp-content/uploads/2023/09/avataaars-6.webp',
  },
  {
    rating: 5,
    comment:
      'I will say that Airbtics is good enough for a small size vacation rental management company. During the demo, they showed me data for my area and it was pretty spot on in terms of prices and occupancy.',
    reviewer: 'James Carlos',
    reviewerRole: 'Revenue Manager @ Ocean Sky Vacation',
    avatar: 'https://airbtics.com/wp-content/uploads/2023/09/avataaars-5.webp',
  },
  {
    rating: 5,
    comment:
      'I had a customized request for data for a research project. I appreciated the personal support from Airbtics very much and received a solution which I am 100% satisfied with for a very favorable price. I would absolutely recommend it.',
    reviewer: 'Selina Steiner',
    reviewerRole: 'Hospitality Researcher @ FHGR.ch',
    avatar: 'https://airbtics.com/wp-content/uploads/2023/09/avataaars-1.webp',
  },
  {
    rating: 5,
    comment:
      "Found a property to purchase in just 2 months of search and it's already under contract with us.",
    reviewer: 'Greg Smith',
    reviewerRole: 'Short-term Rental Investor',
    avatar: 'https://airbtics.com/wp-content/uploads/2023/09/avataaars-7-1.webp',
  },
  {
    rating: 5,
    comment:
      "I used Airbtics last year (2023) and it was very helpful in finding a property and I'm now starting my search for another one.",
    reviewer: 'Denny Ward',
    reviewerRole: 'Property Investor',
    avatar: 'https://airbtics.com/wp-content/uploads/2024/08/avatar323bhbh.svg',
  },
  {
    rating: 5,
    comment:
      'I paid for a full year of Pro Plan because I need the time to investigate a couple of markets in Romania. So far the tool helped.',
    reviewer: 'Marius Blajevschi',
    reviewerRole: 'Property Investor',
    avatar: 'https://airbtics.com/wp-content/uploads/2024/09/avataaars-234234234.svg',
  },
  {
    rating: 5,
    comment:
      'The data has been really useful in that it gives us a good insight into why the highest earning properties are successful (location, sophistication, views etc).',
    reviewer: 'Johnathan Joffe',
    reviewerRole: 'Property Manager',
    avatar: 'https://airbtics.com/wp-content/uploads/2024/09/avataaars-73423i434qwedq.svg',
  },
];

export const CALCULATOR_BLOG_URLS = [
  'airbnb-income-calculator',
  'https://airbtics.com/airbnb-calculator/',
  'https://airbtics.com/airbnb-income-calculator/',
  'https://airbtics.com/calculateur-airbnb/',
  'https://airbtics.com/calculadora-airbnb-pt/',
  'https://airbtics.com/calcolatore-airbnb/',
  'https://airbtics.com/airbnb-rechnerr/',
  'https://airbtics.com/calculadora-airbnb/',
  'https://airbtics.com/%ec%97%90%ec%96%b4%eb%b9%84%ec%95%a4%eb%b9%84-%ed%98%b8%ec%8a%a4%ed%8a%b8-%ec%88%98%ec%9e%85-%ea%b3%84%ec%82%b0%ea%b8%b0/',
];

export const SAMPLE_LISTING_DATA: any = {
  accommodates: 4,
  activeDaysCount: 334,
  adrLTM: 216,
  amenities: {
    parking: false,
    hot_tub: false,
    gym: true,
    pets: false,
    dryer: true,
    washer: true,
    pool: true,
    kitchen: true,
    ac: true,
    wifi: true,
    heating: true,
    tv: true,
    bbq_grill: false,
    fireplace: false,
    breakfast: false,
    beachfront: false,
    amazing_views: true,
  },
  annualRevenueLTM: 61951,
  bathrooms: 1,
  bedrooms: '1',
  cancellation_policy: 's',
  cleaningFee: 150,
  extraGuestFee: 10,
  hasLicense: false,
  hostId: '28767995',
  hostListingCount: 5,
  host_name: 'Parvin',
  last_seen: '2024-12-06',
  latitude: 25.77508,
  listingID: '5620436',
  longitude: -80.13151,
  minimum_nights: 2,
  name: 'Ocean Drive Apartment #403',
  numberOfBookingsLTM: 9,
  occupancyRateLTM: 84,
  property_type: 'Entire rental unit',
  revPAN: 185,
  revenueFromCleaningFeeLTM: 1350,
  revenuePotential: 67886,
  review_scores_rating: 5,
  room_type: 'Entire rental unit',
  thumbnail_url:
    'https://a0.muscache.com/im/pictures/ca944832-ab14-44e6-93ae-9baa452788db.jpg?aki_policy=small',
  visible_review_count: 399,
  rest_thumbnails:
    "['https://a0.muscache.com/im/pictures/ca944832-ab14-44e6-93ae-9baa452788db.jpg?aki_policy=small', 'https://a0.muscache.com/im/pictures/7ac628c1-ab81-4a67-bbee-76c4071b0337.jpg?aki_policy=small', 'https://a0.muscache.com/im/pictures/4845e528-0c7c-453b-9667-6ef83494016a.jpg?aki_policy=small', 'https://a0.muscache.com/im/pictures/cc2f3373-2d6a-4eb0-957a-30c64ec13a5e.jpg?aki_policy=small', 'https://a0.muscache.com/im/pictures/ac304417-800a-4291-97ac-04c90013882c.jpg?aki_policy=small', 'https://a0.muscache.com/im/pictures/68cb1473-2415-4d92-9149-d737d3c19589.jpg?aki_policy=small', 'https://a0.muscache.com/im/pictures/a3d081e7-5efc-4d46-b868-7e15a20cf644.jpg?aki_policy=small', 'https://a0.muscache.com/im/pictures/2f615745-b121-4029-8159-9fb4c0128bda.jpg?aki_policy=small', 'https://a0.muscache.com/im/pictures/d3e7d9d8-263a-4eae-837a-8f3fc8c752f6.jpg?aki_policy=small', 'https://a0.muscache.com/im/pictures/d5b6c770-ce72-4765-8424-786677ab6c06.jpg?aki_policy=small', 'https://a0.muscache.com/im/pictures/ae4ae11c-749f-4c6d-8913-26f5d3324a76.jpg?aki_policy=small', 'https://a0.muscache.com/im/pictures/f12e9d76-3e05-4c17-a5c8-04e8ba413e78.jpg?aki_policy=small', 'https://a0.muscache.com/im/pictures/6c738ed6-6613-4883-b22a-33561a2a2caf.jpg?aki_policy=small', 'https://a0.muscache.com/im/pictures/bfc431ec-dc11-43a2-9c9d-973dbef65d35.jpg?aki_policy=small', 'https://a0.muscache.com/im/pictures/e089140f-8e1b-422c-a8b0-5ee18395d00f.jpg?aki_policy=small', 'https://a0.muscache.com/im/pictures/bb42707f-47c7-4f73-8ae2-0e5bc3fb2bbf.jpg?aki_policy=small', 'https://a0.muscache.com/im/pictures/miso/Hosting-5620436/original/aa167281-8731-423b-8150-94a8bde761cc.jpeg?aki_policy=small', 'https://a0.muscache.com/im/pictures/e0b19aab-dbfd-49c1-b55c-6e3b7e2d2039.jpg?aki_policy=small', 'https://a0.muscache.com/im/pictures/miso/Hosting-5620436/original/2e38da27-ffc0-4c20-8bee-73ac91d15d2f.jpeg?aki_policy=small', 'https://a0.muscache.com/im/pictures/miso/Hosting-5620436/original/83cb3a2d-1d63-4e52-a0ba-c611d0a4d006.jpeg?aki_policy=small', 'https://a0.muscache.com/im/pictures/6843d861-2e07-47ad-ac15-1d0e3f54a576.jpg?aki_policy=small', 'https://a0.muscache.com/im/pictures/61f16358-955c-4eaa-886d-d419177501bd.jpg?aki_policy=small', 'https://a0.muscache.com/im/pictures/c198796a-c321-4b71-8fa3-61b8449c81d8.jpg?aki_policy=small', 'https://a0.muscache.com/im/pictures/074c9ec8-b39f-457a-92f0-f01906fc2cf9.jpg?aki_policy=small']",
};

export const SAMPLE_LISTING_HISTORICAL_DATA: any = [
  {
    month: 'Dec',
    LTMData: {
      occupancy_rate: 58,
      adr: 241,
      revenue: 4263,
      active_days_count: 31,
      days_in_current_month: 31,
    },
    last2YearsData: {
      occupancy_rate: 100,
      adr: 359,
      revenue: 12000,
      active_days_count: 31,
    },
    last3YearsData: {
      occupancy_rate: 100,
      adr: 267,
      revenue: 9794,
      active_days_count: 31,
    },
    latestYear: 2023,
    previousYear: 2022,
    twoYearsBefore: 2021,
    monthYear: 'Dec,23',
  },
  {
    month: 'Jan',
    LTMData: {
      occupancy_rate: 'inactive',
      adr: 'inactive',
      revenue: 'inactive',
      active_days_count: 'inactive',
      days_in_current_month: 31,
      inactivity_reason: 'C60',
    },
    last2YearsData: {
      occupancy_rate: 97,
      adr: 279,
      revenue: 9454,
      active_days_count: 31,
    },
    last3YearsData: {
      occupancy_rate: 100,
      adr: 275,
      revenue: 9888,
      active_days_count: 31,
    },
    latestYear: 2024,
    previousYear: 2023,
    twoYearsBefore: 2022,
    monthYear: 'Jan,24',
  },
  {
    month: 'Feb',
    LTMData: {
      occupancy_rate: 100,
      adr: 244,
      revenue: 7442,
      active_days_count: 29,
      days_in_current_month: 29,
    },
    last2YearsData: {
      occupancy_rate: 100,
      adr: 290,
      revenue: 10345,
      active_days_count: 28,
    },
    last3YearsData: {
      occupancy_rate: 100,
      adr: 276,
      revenue: 9918,
      active_days_count: 28,
    },
    latestYear: 2024,
    previousYear: 2023,
    twoYearsBefore: 2022,
    monthYear: 'Feb,24',
  },
  {
    month: 'Mar',
    LTMData: {
      occupancy_rate: 100,
      adr: 260,
      revenue: 7930,
      active_days_count: 31,
      days_in_current_month: 31,
    },
    last2YearsData: {
      occupancy_rate: 100,
      adr: 277,
      revenue: 10998,
      active_days_count: 31,
    },
    last3YearsData: {
      occupancy_rate: 100,
      adr: 287,
      revenue: 10554,
      active_days_count: 31,
    },
    latestYear: 2024,
    previousYear: 2023,
    twoYearsBefore: 2022,
    monthYear: 'Mar,24',
  },
  {
    month: 'Apr',
    LTMData: {
      occupancy_rate: 96,
      adr: 236,
      revenue: 6910,
      active_days_count: 30,
      days_in_current_month: 30,
    },
    last2YearsData: {
      occupancy_rate: 100,
      adr: 246,
      revenue: 9303,
      active_days_count: 30,
    },
    last3YearsData: {
      occupancy_rate: 100,
      adr: 287,
      revenue: 10104,
      active_days_count: 30,
    },
    latestYear: 2024,
    previousYear: 2023,
    twoYearsBefore: 2022,
    monthYear: 'Apr,24',
  },
  {
    month: 'May',
    LTMData: {
      occupancy_rate: 81,
      adr: 215,
      revenue: 5612,
      active_days_count: 31,
      days_in_current_month: 31,
    },
    last2YearsData: {
      occupancy_rate: 93,
      adr: 248,
      revenue: 7935,
      active_days_count: 27,
    },
    last3YearsData: {
      occupancy_rate: 85,
      adr: 282,
      revenue: 8661,
      active_days_count: 31,
    },
    latestYear: 2024,
    previousYear: 2023,
    twoYearsBefore: 2022,
    monthYear: 'May,24',
  },
  {
    month: 'Jun',
    LTMData: {
      occupancy_rate: 80,
      adr: 193,
      revenue: 4709,
      active_days_count: 30,
      days_in_current_month: 30,
    },
    last2YearsData: {
      occupancy_rate: 100,
      adr: 205,
      revenue: 7152,
      active_days_count: 22,
    },
    last3YearsData: {
      occupancy_rate: 76,
      adr: 230,
      revenue: 6531,
      active_days_count: 30,
    },
    latestYear: 2024,
    previousYear: 2023,
    twoYearsBefore: 2022,
    monthYear: 'Jun,24',
  },
  {
    month: 'Jul',
    LTMData: {
      occupancy_rate: 93,
      adr: 198,
      revenue: 5766,
      active_days_count: 31,
      days_in_current_month: 31,
    },
    last2YearsData: {
      occupancy_rate: 80,
      adr: 190,
      revenue: 5386,
      active_days_count: 30,
    },
    last3YearsData: {
      occupancy_rate: 89,
      adr: 219,
      revenue: 7445,
      active_days_count: 31,
    },
    latestYear: 2024,
    previousYear: 2023,
    twoYearsBefore: 2022,
    monthYear: 'Jul,24',
  },
  {
    month: 'Aug',
    LTMData: {
      occupancy_rate: 89,
      adr: 180,
      revenue: 5336,
      active_days_count: 31,
      days_in_current_month: 31,
    },
    last2YearsData: {
      occupancy_rate: 81,
      adr: 193,
      revenue: 5668,
      active_days_count: 31,
    },
    last3YearsData: {
      occupancy_rate: 58,
      adr: 201,
      revenue: 4606,
      active_days_count: 31,
    },
    latestYear: 2024,
    previousYear: 2023,
    twoYearsBefore: 2022,
    monthYear: 'Aug,24',
  },
  {
    month: 'Sep',
    LTMData: {
      occupancy_rate: 62,
      adr: 180,
      revenue: 3554,
      active_days_count: 29,
      days_in_current_month: 30,
    },
    last2YearsData: {
      occupancy_rate: 72,
      adr: 187,
      revenue: 4257,
      active_days_count: 30,
    },
    last3YearsData: {
      occupancy_rate: 84,
      adr: 179,
      revenue: 5786,
      active_days_count: 30,
    },
    latestYear: 2024,
    previousYear: 2023,
    twoYearsBefore: 2022,
    monthYear: 'Sep,24',
  },
  {
    month: 'Oct',
    LTMData: {
      occupancy_rate: 93,
      adr: 202,
      revenue: 5730,
      active_days_count: 31,
      days_in_current_month: 31,
    },
    last2YearsData: {
      occupancy_rate: 50,
      adr: 187,
      revenue: 2852,
      active_days_count: 31,
    },
    last3YearsData: {
      occupancy_rate: 97,
      adr: 186,
      revenue: 7303,
      active_days_count: 31,
    },
    latestYear: 2024,
    previousYear: 2023,
    twoYearsBefore: 2022,
    monthYear: 'Oct,24',
  },
  {
    month: 'Nov',
    LTMData: {
      occupancy_rate: 76,
      adr: 219,
      revenue: 5376,
      active_days_count: 30,
      days_in_current_month: 30,
    },
    last2YearsData: {
      occupancy_rate: 54,
      adr: 197,
      revenue: 3545,
      active_days_count: 29,
    },
    last3YearsData: {
      occupancy_rate: 84,
      adr: 230,
      revenue: 7393,
      active_days_count: 30,
    },
    latestYear: 2024,
    previousYear: 2023,
    twoYearsBefore: 2022,
    monthYear: 'Nov,24',
  },
];

export const PRICING_TABLE_TOOLTIPS = {
  historical_data: {
    content: 'Access up to 2021 to view trends and make informed decisions.',
  },
  market_overview: {
    content: 'View an overview of every market to analyze average performance and trends.',
  },
  market_details: {
    content:
      'Access detailed insights, including seasonality, market trends, occupancy rates by bedroom count, and over 30 additional key data points',
  },
  market_explorer: {
    content:
      'Each search returns up to 20 markets. Your credit is only used when you click the Search button.',
  },
  market_pacing_insights: {
    content: 'Coming soon.',
  },
  guest_demographics: {
    content:
      'Explore a detailed breakdown of short-term rental guests, including their origin cities, countries, and preferred languages.',
  },
  host_performance_overview: {
    content:
      'Explore a comprehensive breakdown of hosts, featuring their average daily rate, occupancy rate, and performance statistics across all their listings.',
  },
  interactive_map_insights: {
    content:
      'Access key performance metrics of listings directly within the map view. The data updates dynamically as you navigate, allowing for hyper-localized analysis.',
  },
  calculator_estimator: {
    content: 'Calculate the revenue potential of any address in the world.',
  },
  listing_overview: { content: 'Access metrics of all active short-term rentals.' },
  listing_performance_breakdown: {
    content: 'Access 12 months detailed performance breakdown of all active short-term rentals.',
  },
  listing_filters: {
    content: 'Filter properties based on bedroom or bathroom to narrow down your search.',
  },
  amenities_performance_filters: {
    content:
      'Filter properties based on amenities they have (e.g. pool) or revenue (e.g. low occupancy listings)',
  },
  markets_included: { content: 'Access short-term rental data from any market worldwide.' },
  draw_custom_markets: {
    content:
      'Draw custom markets on the map to access detailed short-term rental insights for any location worldwide',
  },
  market_table_view_discovery: {
    content:
      'View key performance metrics and year-over-year changes for up to 20 markets in a table format, with the option to export the data. ',
  },
  property_manager_view: {
    content:
      'View a table of host breakdowns, including average daily rate, occupancy rate, and listing performance. Download data for up to 20 markets covering all hosts.',
  },
  property_manager_view_1: {
    content:
      'View a table of host breakdowns, including average daily rate, occupancy rate, and listing performance. Download data for up to 1 markets covering all hosts.',
  },
  market_insights_export: {
    content:
      'Download key performance metrics for up to 20 markets directly into an Excel file for easy analysis.',
  },
  market_compare: {
    content: 'Compare as many markets as you need directly in the platform.',
  },
  report_compare: {
    content: 'Compare reports without limits directly in the platform.',
  },
  csv_data_downloads: {
    content: 'Download key market metrics as seen on the dashboard (up to 20 markets).',
  },
  csv_data_downloads_market_compare: {
    content: 'Export comparison results for up to 20 markets.',
  },
  csv_data_downloads_report_compare: {
    content: 'Export up to 50 reports for deeper market insights.',
  },
  csv_data_downloads_individual_listing: {
    content:
      'Listing-level data is available as an add-on ($150–$600 based on granularity and volume). See market page for details.',
  },
  unlimited_calculator: {
    content:
      'Create unlimited Airbnb revenue reports worldwide. Access detailed insights, including seasonality, market trends, occupancy rates, comps, and over 30 key data points. Suitable for property investors, rental arbitrage, realtors or property managers.',
  },
  basic_listing_insight: {
    content: 'Access metrics of all active short-term rentals (Yearly granularity).',
  },
  market_explorar: {
    content:
      'Get 5 AI-powered market recommendations per month based on your budget, location, regulations, and market type preferences. Discover 20–50 tailored short-term rental markets each time.',
  },
  saved_markets_20: {
    content: 'Save and track up to 20 markets.',
  },
  saved_markets_100: {
    content: 'Save and track up to 100 markets.',
  },
  filters: {
    content:
      'Use filters to refine listings by type, performance, or amenities. Changes reflect in the Overview dashboard too.',
  },
  calculator_pdf_export: {
    content: 'Export calculator reports as a branded PDF report.',
  },
  multiple_saved_markets_list: {
    content:
      'Save and organize markets into multiple lists—ideal for managing clients or strategies.',
  },
  advanced_listing_insight: {
    content:
      'Access metrics of all active short-term rentals. Monthly granularity: 12-month breakdown of historical occupancy rate, daily rate, and revenue of individual listing.',
  },
  export_200_rows: {
    content:
      "Download key market metrics of up to 200 markets. You can download your saved markets, saved calculator reports, market explorer results, and the top Airbnb management companies list. Note that you can't download individual listing data - is only available as an add-on ($150 - $2,000 per market based on granularity). Check the market page to purchase.",
  },
  market_explorar_20: {
    content:
      'Get 20 AI-powered market recommendations per month based on your budget, location, regulations, and market type preferences. Discover 20–50 tailored short-term rental markets each time.',
  },
};

export const USER_REFERRED_CURRENCY = 'user-preferred-currency';

export const USER_MARKET_COMPARISON_COUNT = 'market-compare-count';
export const USER_REPORT_COMPARISON_COUNT = 'report-compare-count';

export const GET_MARKET_DATA_CACHE_URL =
  'https://43kxfqfm00.execute-api.us-east-2.amazonaws.com/default/getMarketDataCacheTest';
// export const GET_MARKET_DATA_CACHE_URL =
//   'https://6co0gb5kb6.execute-api.us-east-2.amazonaws.com/prod/getMarketDataCache';

export const GET_TOP_HOST_DETAILS_URL =
  'https://xfs76ukxc5.execute-api.us-east-2.amazonaws.com/default/getTopHostDetails';

export const SAVE_USER_DATA_LAMBDA_URL =
  'https://fld2j6mes8.execute-api.us-east-2.amazonaws.com/default/updateUserDetails';

export const MONTHLY_TOP_HOST_LIMIT = {
  expert: 1,
  scale: 20,
};

export const MONTHLY_BEST_MARKET_FINDER_LIMIT = {
  expert: 5,
  scale: 20,
};

export const TOP_HOST_TOOLTIP_MAP = {
  listings:
    'Total number of listings managed by this host, including those outside the current market.',
  avg_rating: '',
  avg_revenue: 'Average revenue per listing, calculated over the last 12 months.',
  avg_occupancy_rate:
    'Average occupancy rate for the managed listings, based on data from the past 12 months.',
  avg_daily_rate: 'Average daily rate per managed listing, calculated over the past 12 months.',
  most_common_bedroom: '',
  inventory_growth: '',
};

export const DEMO_INDIVIDUAL_HOST_DATA = {
  good_reviews:
    '[{"id": 1075102197949771462, "rating": 5, "comments": "Very good place with very clean house", "language": "en", "reviewee": null, "reviewer": 101954353, "listingID": 988026964058711601, "created_at": "2024-01-23"}, {"id": 1073670198102960510, "rating": 5, "comments": "I had a wonderful stay at this Airbnb. The room was incredibly spacious, and the services like taxi and vehicle rental made exploring the area convenient. Condolim Beach, just 10 minutes away by vehicle, was a highlight. The presence of security guards and ample parking space added to the overall positive experience. Highly recommended!", "language": "en", "reviewee": null, "reviewer": 437757941, "listingID": 40514889, "created_at": "2024-01-21"}, {"id": 1068584770165658181, "rating": 5, "comments": "It’s a beautiful place. The rooms need a bit of maintenance but otherwise helpful staff and good location to move around on bikes", "language": "en", "reviewee": null, "reviewer": 238748284, "listingID": 47501120, "created_at": "2024-01-14"}, {"id": 1067873256201559123, "rating": 5, "comments": "Lovely stay at LaZamora villa! Housekeeping was great. Not to forget Lipu, he was great with cleaning and providing other amenities. Cohost Leon was very friendly and helpful. Looking forward to stay again.", "language": "en", "reviewee": null, "reviewer": 546930336, "listingID": 53175503, "created_at": "2024-01-13"}, {"id": 1067830290267824384, "rating": 5, "comments": "Excellent location, spacious and clean villa, responsive hosts and a super comfortable bed. All that you need for a short/long stay in Goa. Will come back!", "language": "en", "reviewee": null, "reviewer": 33170721, "listingID": 1006283563470162017, "created_at": "2024-01-13"}]',
  inventory_growth: 25,
  adr: 197,
  most_common_bedroom: '2',
  occupancy_rate: 75,
  rating: 4.8,
  revenue: 33000,
  listings: 12212,
};

export const HEATMAP_METRIC_TO_DATA_KEY_MAP = {
  listing: {
    dataKey: 'listingCount',
    metric: 'Supply',
  },
  occupancy: {
    dataKey: 'occupancyRate',
    metric: 'Occupancy Rate',
  },
  revenue: {
    dataKey: 'revenue',
    metric: 'Revenue',
  },
};

export const GOOGLE_MAPS_DEEPEST_ZOOM_LEVEL = 22;
export const MONTHLY_BOOKING_DATA = [
  {
    month: '2024-05',
    avg_length_of_stay: 3.8,
  },
  {
    month: '2024-06',
    avg_length_of_stay: 3.7,
  },
  {
    month: '2024-07',
    avg_length_of_stay: 3.6,
  },
  {
    month: '2024-08',
    avg_length_of_stay: 3.8,
  },
  {
    month: '2024-09',
    avg_length_of_stay: 4,
  },
  {
    month: '2024-10',
    avg_length_of_stay: 3.5,
  },
  {
    month: '2024-11',
    avg_length_of_stay: 3.6,
  },
  {
    month: '2024-12',
    avg_length_of_stay: 3.5,
  },
  {
    month: '2025-01',
    avg_length_of_stay: 3.5,
  },
  {
    month: '2025-02',
    avg_length_of_stay: 3.4,
  },
];

export const BEST_AIRBNB_MARKET_COUNTRY_CODE_MAP = {
  ID: 'Indonesia',
  FR: 'France',
  US: 'United States',
  GB: 'United Kingdom',
  DE: 'Germany',
  IT: 'Italy',
  ME: 'Montenegro',
  CA: 'Canada',
  AU: 'Australia',
  PH: 'Philippines',
  LV: 'Latvia',
  IE: 'Ireland',
  DK: 'Denmark',
  LU: 'Luxembourg',
  NZ: 'New Zealand',
  EG: 'Egypt',
  NG: 'Nigeria',
  MY: 'Malaysia',
  CH: 'Switzerland',
  CZ: 'Czechia',
  HK: 'Hong Kong',
  MX: 'Mexico',
  KR: 'South Korea',
  CL: 'Chile',
  PE: 'Peru',
  AR: 'Argentina',
  IN: 'India',
  CO: 'Columbia',
  BG: 'Bulgaria',
  JP: 'Japan',
  PT: 'Portugal',
  PL: 'Poland',
  ZA: 'South Africa',
  IL: 'Israel',
  PY: 'Paraguay',
  HU: 'Hungary',
  BE: 'Belgium',
  AT: 'Austria',
  GR: 'Greece',
  CY: 'Cyprus',
  FI: 'Finland',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  SE: 'Sweden',
  KE: 'Kenya',
  UY: 'Uruguay',
  MA: 'Morocco',
  RS: 'Serbia',
  CR: 'Costa Rica',
  NO: 'Norway',
  RO: 'Romania',
  EE: 'Estonia',
  BR: 'Brazil',
  TH: 'Thailand',
  AL: 'Albania',
  TN: 'Tunisia',
  MT: 'Malta',
  KZ: 'Kazakhstan',
  TZ: 'Tanzania',
  IS: 'Iceland',
  NL: 'Netherlands',
  VN: 'Vietnam',
  ES: 'Spain',
  AE: 'United Arab Emirates',
  SA: 'Saudi Arabia',
  TW: 'Taiwan',
  HR: 'Croatia',
  TR: 'Turkey',
  GE: 'Georgia',
  CU: 'Cuba',
  UA: 'Ukraine',
  AM: 'Armenia',
  MN: 'Mongolia',
  PR: 'Puerto Rico',
  FJ: 'Fiji',
  AW: 'Aruba',
  BZ: 'Belize',
  GT: 'Guatemala',
  NP: 'Nepal',
  MG: 'Madagascar',
  KN: 'Saint Kitts and Nevis',
  TT: 'Trinidad and Tobago',
  SG: 'Singapore',
  XK: 'Kosovo',
};

export const MAILCHIMP_FIELDS = {
  LATEST_INTERESTED_COUNTRY: 'latestInterestedCountry',
  LATEST_INTERESTED_COUNTRY_BEST_MARKET_BLOG_URL: 'latestInterestedCountryBestMarketBlogUrl',
  LATEST_INTERESTED_MARKET: 'latestInterestedMarket',
  LATEST_INTERESTED_MARKET_APP_URL: 'latestInterestedMarketAppUrl',
  LATEST_INTERESTED_REPORT_URL: 'latestInterestedReportUrl',
  HAS_SHOWN_PAYMENT_INTEREST: 'hasShownPaymentInterest',
};

export const COUNTRY_ALIASES: Record<string, string> = {
  usa: 'United States',
  us: 'United States',
  uk: 'United Kingdom',
  gb: 'United Kingdom',
  uae: 'United Arab Emirates',
  southkorea: 'South Korea',
  korea: 'South Korea',
  hongkong: 'Hong Kong',
};

export const BEST_MARKET_BLOGS_WITH_THE_PREFIX = ['united-states', 'united-kingdom'];

export const MARKET_FINDER_COLUMN_METADATA = {
  short_term_rental_yield: {
    unit: '%',
    is_currency: false,
    display_name: 'Short-term rental yield',
    is_sortable: true,
    data_type: 'number',
    width: 200,
  },
  rent_gap: {
    unit: 'USD',
    is_currency: true,
    display_name: 'Rent gap',
    is_sortable: true,
    data_type: 'number',
    width: 150,
  },
  occupancy_rate: {
    unit: '%',
    is_currency: false,
    display_name: 'Occupancy Rate',
    is_sortable: true,
    data_type: 'number',
    width: 160,
  },
  adr: {
    unit: 'USD',
    is_currency: true,
    display_name: 'ADR',
    is_sortable: true,
    data_type: 'number',
    width: 120,
  },
  revenue: {
    unit: 'USD',
    is_currency: true,
    display_name: 'Average Revenue (2 BD)',
    is_sortable: true,
    data_type: 'number',
    width: 220,
  },
  supply: {
    unit: 'count',
    is_currency: false,
    display_name: 'Number of listings',
    is_sortable: true,
    data_type: 'integer',
    width: 180,
  },
  regulation: {
    unit: null,
    is_currency: false,
    display_name: 'Regulations',
    is_sortable: false,
    data_type: 'string',
    width: 160,
  },
  yoy_supply_change: {
    unit: '%',
    is_currency: false,
    display_name: 'YoY Supply Change',
    is_sortable: true,
    data_type: 'number',
    width: 180,
  },
  yoy_revenue_change: {
    unit: '%',
    is_currency: false,
    display_name: 'YoY Revenue Change',
    is_sortable: true,
    data_type: 'number',
    width: 180,
  },
};

export const MARKET_FINDER_COLUMN_METADATA_ORDER = [
  'regulation',
  'supply',
  'short_term_rental_yield',
  'rent_gap',
  'revenue',
  'occupancy_rate',
  'adr',
  'yoy_supply_change',
  'yoy_revenue_change',
];

export const usStateListWithCode = [
  { code: 'AL', label: 'Alabama' },
  { code: 'AK', label: 'Alaska' },
  { code: 'AZ', label: 'Arizona' },
  { code: 'AR', label: 'Arkansas' },
  { code: 'CA', label: 'California' },
  { code: 'CO', label: 'Colorado' },
  { code: 'CT', label: 'Connecticut' },
  { code: 'DE', label: 'Delaware' },
  { code: 'FL', label: 'Florida' },
  { code: 'GA', label: 'Georgia' },
  { code: 'HI', label: 'Hawaii' },
  { code: 'ID', label: 'Idaho' },
  { code: 'IL', label: 'Illinois' },
  { code: 'IN', label: 'Indiana' },
  { code: 'IA', label: 'Iowa' },
  { code: 'KS', label: 'Kansas' },
  { code: 'KY', label: 'Kentucky' },
  { code: 'LA', label: 'Louisiana' },
  { code: 'ME', label: 'Maine' },
  { code: 'MD', label: 'Maryland' },
  { code: 'MA', label: 'Massachusetts' },
  { code: 'MI', label: 'Michigan' },
  { code: 'MN', label: 'Minnesota' },
  { code: 'MS', label: 'Mississippi' },
  { code: 'MO', label: 'Missouri' },
  { code: 'MT', label: 'Montana' },
  { code: 'NE', label: 'Nebraska' },
  { code: 'NV', label: 'Nevada' },
  { code: 'NH', label: 'New Hampshire' },
  { code: 'NJ', label: 'New Jersey' },
  { code: 'NM', label: 'New Mexico' },
  { code: 'NY', label: 'New York' },
  { code: 'NC', label: 'North Carolina' },
  { code: 'ND', label: 'North Dakota' },
  { code: 'OH', label: 'Ohio' },
  { code: 'OK', label: 'Oklahoma' },
  { code: 'OR', label: 'Oregon' },
  { code: 'PA', label: 'Pennsylvania' },
  { code: 'RI', label: 'Rhode Island' },
  { code: 'SC', label: 'South Carolina' },
  { code: 'SD', label: 'South Dakota' },
  { code: 'TN', label: 'Tennessee' },
  { code: 'TX', label: 'Texas' },
  { code: 'UT', label: 'Utah' },
  { code: 'VT', label: 'Vermont' },
  { code: 'VA', label: 'Virginia' },
  { code: 'WA', label: 'Washington' },
  { code: 'WV', label: 'West Virginia' },
  { code: 'WI', label: 'Wisconsin' },
  { code: 'WY', label: 'Wyoming' },
];

export const DEFAULT_FILTER_VALUES = {
  roomType: [],
  bedrooms: [100],
  bathrooms: [100],
  revenueFilter: [],
  priceTierFilter: [],
  accommodates: [1, 16],
  minimum_nights: [1, 30],
  number_of_reviews: 'all',
  rating: [3.9, 5],
  hostType: 'both',
  amenities: {
    pool: null,
    parking: null,
    hot_tub: null,
    gym: null,
    pets: null,
    dryer: null,
    washer: null,
    kitchen: null,
    ac: null,
    heating: null,
    wifi: null,
    tv: null,
    bbq_grill: null,
    fireplace: null,
    breakfast: null,
    beachfront: null,
    amazing_views: null,
  },
};

export const PRICE_TIERS = ['Budget', 'Economy', 'Midscale', 'Upscale', 'Luxury'];

export const SAVED_MARKETS_POPUP_MESSAGE_THRESHOLD = 2;
export const SAVED_MARKETS_PAGE_URL = '/airbnb-data/landing';
export const SAVED_MARKET_FREE_USER_LIMIT = 5;

export const SAVED_MARKET_RE_DIRECTION_MODAL_CLOSED_KEY =
  'keep-saved-market-re-direction-modal-closed';

// ===============================
// Region Filter Constants
// ===============================
export const macro_to_subgroups = {
  NA: ['NA'],
  MEA: ['MENA', 'SSA'],
  AS: ['SEA', 'EA', 'CA', 'SA'],
  EU: ['WEU', 'SEU', 'NEU', 'EEU', 'BALK'],
  LATAM: ['CAM', 'CAR', 'SAM'],
  OC: ['ANZ', 'PI'],
};

export const macro_group_legends = {
  MEA: 'Middle East & Africa',
  AS: 'Asia',
  EU: 'Europe',
  LATAM: 'Latin America',
  NA: 'North America',
  OC: 'Oceania',
};

export const sub_group_legends = {
  // MEA
  MENA: 'Middle East & North Africa',
  SSA: 'Sub-Saharan Africa',
  // AS
  SEA: 'Southeast Asia',
  EA: 'East Asia',
  CA: 'Central Asia',
  SA: 'South Asia',
  // EU
  WEU: 'Western Europe',
  SEU: 'Southern Europe',
  NEU: 'Northern Europe',
  EEU: 'Eastern Europe',
  BALK: 'Balkans',
  // LATAM
  CAM: 'Central America',
  CAR: 'Caribbean',
  SAM: 'South America',
  // OC
  ANZ: 'Australia & New Zealand',
  PI: 'Pacific Islands',
  NA: 'North America',
};

export const subGroupToCountryCodes = {
  ANZ: ['AU', 'NZ'],
  BALK: ['AL', 'BA', 'GR', 'HR', 'ME', 'MK', 'RO', 'RS', 'SI', 'TR', 'XK'],
  CA: ['AM', 'AZ', 'KG', 'KZ', 'TJ', 'TM', 'UZ'],
  CAM: ['BZ', 'CR', 'GT', 'HN', 'NI', 'PA', 'SV'],
  CAR: [
    'AG',
    'AI',
    'AN',
    'AW',
    'BB',
    'BL',
    'BQ',
    'BS',
    'CU',
    'CW',
    'DM',
    'DO',
    'GD',
    'GP',
    'HT',
    'JM',
    'KN',
    'KY',
    'LC',
    'MF',
    'MQ',
    'PR',
    'SX',
    'TC',
    'TT',
    'VC',
    'VG',
    'VI',
  ],
  EA: ['CN', 'HK', 'JP', 'KR', 'MN', 'MO', 'TW'],
  EEU: ['BG', 'BY', 'CZ', 'HU', 'MD', 'PL', 'RU', 'SK', 'UA'],
  MENA: [
    'AE',
    'BH',
    'DZ',
    'EG',
    'IL',
    'IQ',
    'JO',
    'KW',
    'LB',
    'LY',
    'MA',
    'OM',
    'PS',
    'QA',
    'SA',
    'TN',
  ],
  NEU: ['AX', 'DK', 'EE', 'FI', 'FO', 'GB', 'IE', 'IS', 'LT', 'LV', 'NO', 'SE', 'SJ'],
  PI: ['AS', 'CK', 'FJ', 'FM', 'GU', 'NC', 'PF', 'PG', 'PW', 'SB', 'TO', 'TV', 'VU', 'WS'],
  SA: ['AF', 'BD', 'BT', 'IN', 'LK', 'MV', 'NP', 'PK'],
  SAM: ['AR', 'BO', 'BR', 'CL', 'CO', 'EC', 'GF', 'GY', 'PE', 'PY', 'SR', 'UY', 'VE'],
  SEA: ['BN', 'ID', 'KH', 'LA', 'MM', 'MY', 'PH', 'SG', 'TH', 'TL', 'VN'],
  SEU: ['CY', 'ES', 'IT', 'MT', 'PT'],
  SSA: [
    'AO',
    'BF',
    'BI',
    'BJ',
    'BW',
    'CD',
    'CF',
    'CG',
    'CI',
    'CM',
    'CV',
    'ER',
    'ET',
    'GA',
    'GH',
    'GM',
    'GN',
    'GW',
    'KE',
    'KM',
    'LS',
    'MG',
    'ML',
    'MR',
    'MU',
    'MW',
    'MZ',
    'NA',
    'NE',
    'NG',
    'RE',
    'RW',
    'SC',
    'SD',
    'SH',
    'SL',
    'SN',
    'SO',
    'ST',
    'SZ',
    'TG',
    'TZ',
    'UG',
    'YT',
    'ZA',
    'ZM',
    'ZW',
  ],
  WEU: ['AD', 'AT', 'BE', 'CH', 'DE', 'FR', 'GG', 'IM', 'JE', 'LI', 'LU', 'MC', 'NL'],
  NA: ['BM', 'CA', 'CX', 'EH', 'GE', 'GI', 'GL', 'NF', 'US', 'WF'],
};

export const DEFAULT_SELECTED_COLUMNS_EXPLORER = [
  'market_grade',
  'regulation',
  'supply',
  'revenue',
  'occupancy_rate',
  'adr',
  'yoy_supply_change',
  'yoy_revenue_change',
  'short_term_rental_yield',
  'rent_gap',
];

export const SAVED_LIMIT_MAX_LIMIT = 20;

export const USER_WISE_SAVE_LIST_LIMIT = {
  starter: 5,
  expert: 20,
  scale: 100,
};

export const USER_WISE_LIST_CREATE_LIMIT = {
  starter: 1,
  expert: 1,
  scale: Number.MAX_SAFE_INTEGER,
};

export const LAST_SELECTED_MARKET_LIST_ID = 'last-selected-market-list-id';
export const SELECTED_MARKET_LIST_ORDER = 'selected-market-list-order';

export const MARKET_EXPLORER_EXPORT_LIMIT_ROW_MONTHLY = 200;

export const DELETABLE_SUBSCRIPTION_STATUS = ['active', 'past due', 'unpaid'];